// 1. 需要事先取得的資料: isDataPrerequisiteGotton
//     這些資料會存在 CachedContext
// GetPrerequisiteDataProcessBegin
//         // 1. History
//         // 2. Temp Answer List
// GetPrerequisiteDataProcessBegin
// 2. 如果要開始 SR, 事先需要初始: isSRPrerequisiteGotton
// InitSRPrerequisiteProcessBegin
//         // 1. WebAudioRecorder
//         // 2. SREngine
//         // 3. Pinyin Files
//         // 都完成，或是有遇到 Init Error
//         // 就進入 InitSRPrerequisiteProcessEnd
// InitSRPrerequisiteProcessEnd

import React, { useEffect, useState, useRef, useContext } from 'react'
import cssPracticeFluency from './PracticeFluency.module.scss'
import { LUCacheContext } from '../../LearningUnit.js'

// import * as WebSpeech from '../../../Utils/SR/WebSpeech'
// import * as SRInApp from '../../../Utils/SR/SRInApp'
import mp3VoiceNotDetected from "../../../Resources/Audio/VoiceNotDetected.mp3"
import mp3GameCorrectAnswer from "../../../Resources/Audio/GameCorrectAnswer.mp3"
import ReadAloudAns from '../../LUUtils/ReadAloudAns/ReadAloudAns'

import {
    LocalStorageLibs, 
    SRFunctions, 
    WebSpeech, 
    SRInApp, 
    GoogleShareToClassRoom, 
    PackageVariablesLibs,
    WebAudioRecorderLibs,
    ClientGatewayInPackage,
    GlobalLibs,
    NetworkLibs
} from 'bc-react-package'

// #region Constant
const COMP_NAME = "PracticeFluency"
const MAX_SILENCE_MS = 3000
const SHOW_SR_RESULT_DEBUG = true
const INDEX_NONE = -1
const SCROE_DEFAULT = -1
// #endregion Constant

// #region Enumeration
const ReadAloudStateEnum = {
    "None": 0,
    "Initing": 1,
    "Inited": 2,
    "InitedWebAudioRecorderFailed": 3,      // 初始 WebAudioRecorder 出錯：沒權限，。。。
    "InitedSRFailed": 4,    // 初始 SR Engine 出錯
    "QuestionAudioPlaying": 5,
    "QuestionAudioEnded": 6,
    "UserRecording": 7,
    "UserRecordStopped": 8,
    "ResultProcessed": 9,
    "SRErrorProcessing": 10,
    "SRErrorProcessed": 11      // SR 錯誤 Alert 之後
}

const PlayAudioTypeEnum = {
    "None": 0,
    "VoiceNotDetected": 1,
    "VocabularyAudio": 2,
    "UserRecordedAudio": 3,
    "GameCorrectAnswer": 4,
    "UserClickedAudio": 5
}

const TestSheetModeEnum = {
    New: 1,
    Temp: 2,
    History: 3
}

const AudioType = {
    None: 0,
    QuestionAudio: 1,
    StudentVoice: 2
}
// #endregion Enumeration

// #region Member Variables
let mblnInitialized = false
let mobjWebAudioRecorder = null
let mblnSRSupport = false
let marrSRResults = []
let mstrLUKey4LUCachedContext = "" // 用於從LUCacheContext 取出 Cache的LU資料時 指出此LU時所需的Key
let mintPlayAudioType = PlayAudioTypeEnum.None
let mintIndex4HistoryItemToShow = -1
let marrAnswerList4Save = []
let marrAnswerList4Submit = []
let mfltAvgScore4Submit = 0
let mstrLUCatSeqNo = ""
let mintSRResultErrorCount = 0
let mintCurrentSentenceIndex = -1
let mintTotalSentence = 0
let mstrBookCatID = ""
let mobjForceStopSRTimer = null
let mintClassID = -1
let mobjArgs4UploadUserRecordedAudio = {}
// {
//     "Args4UploadUserRecordedAudio": "{\"AccID\":459,\"BookCategoryID\":\"03\",\"LessonID\":\"03001\",\"LUCatSeqNo\":28,\"ClassID\":\"57\",\"TRSeqNo\":0,\"TRPIndex\":2,\"DateType\":1,\"ContentType\":\"MFCW\"}"
// }
let mobjTestSheet = {
    Mode: TestSheetModeEnum.New,
    Score: SCROE_DEFAULT,
    Dirty: false,
    Sentence: []
}

let mobjAnswer = {
}

let mobjTipFlags = {
    "IsMicTipAgainFirst": true, // 是否是進入LU後 第一次點擊麥克風後 取得SR結果 若SR分數不合格 提示再按一次麥克風重新做SR
    "IsNextTipFirst": true, // 是否是進入LU後 第一次SR分數通過 提示按下一題
    "IsAudioTipFirst": true // 是否是進入LU後 第一次SR完成
}

// SentenceIndex:正在播放中的Index, AudioType: 是哪一種聲音QuestionAudio或StudentVoice
let mobjPlayingAudioIndex = {
    SentenceIndex: INDEX_NONE,
    AudioType: AudioType.None
}

let mblnPracticeEnable = true // 1) 老師設定 Show Practice/Review to Student 決定是否允許學生作答 2）當有允許時 是否有超過最多作答次數 Submission次數的設定可能是 至多1次 至多2次 或 無限多次
let mstrPracticeDisableMessage = "" // 當不允許Practice時 要顯示的訊息
// #endregion Member Variables

/* Tip顯示規則

--- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

LocalStorageLibs.GetAccLSElement("IsMicTipFirst")
LocalStorageLibs.SetAccLSElement("IsMicTipFirst", NewValue)

何時 顯示Tip
1. 第一次點擊開始錄音按鈕 開始可以錄音時 顯示tip

何時 關閉Tip
1. 錄音過程中 點擊 麥克風 關閉Tip
2. 點擊 上/下一題按鈕 關閉Tip

3. 點擊 Try Again
4. 點擊 History的Temp或Detail都關閉

何時 IsMicTipFirst 設為 false
1. 錄音過程中 點擊 麥克風 麥克風
2. 離開 LU (一進來 都沒有按 就去其他LU)
3. 點擊 History(歷史紀錄)
4. 點擊 上/下一題按鈕 

--- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

LBL_MicTipAgain - Please tap mic again
LocalStorageLibs.GetAccLSElement("IsMicTipAgainFirst")
LocalStorageLibs.SetAccLSElement("IsMicTipAgainFirst", NewValue)

何時 顯示
1. 錄完之後 第一次沒有Pass 顯示

何時 IsMicTipAgainFirst 設為 false
1. Tip顯示後 點擊 麥克風
2. Tip顯示後 點擊 上/下一題
3. Tip顯示後 點擊 Retry
4. Tip顯示後 點擊 History

何時關閉
1. 點擊 麥克風
2. 點擊 上/下一題
3. 點擊 Retry
4. 點擊 History

--- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

LBL_NextTip - Please tap button to next sentence
LocalStorageLibs.GetAccLSElement("IsNextTipFirst")
LocalStorageLibs.SetAccLSElement("IsNextTipFirst", NewValue)

何時 顯示
1. 當第一次Pass的時候 顯示

何時 IsNextTipFirst 設為 false
1. 點擊 下一題按鈕
2. 點擊 Retry
3. 點擊 History

何時關閉
1. 點擊 下一題按鈕
2. 點擊 Retry
3. 點擊 History

--- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

LBL_AudioTip
LocalStorageLibs.GetAccLSElement("IsAudioTipFirst")
LocalStorageLibs.SetAccLSElement("IsAudioTipFirst", NewValue)

何時 顯示
1. 第一次SR後 顯示在題目的左方

何時 IsAudioTipFirst設定為false
1. 點擊 播放音檔
2. 點擊 上/下題的時 關閉
3. 點擊 Retry
4. 點擊 History的Temp或Detail都關閉

何時關閉
1. 點擊 播放音檔
2. 點擊 上/下題的時 關閉
3. 點擊 Retry
4. 點擊 History的Temp或Detail都關閉

--- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
*/

function PracticeFluency(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)

    // #region Init State
    const [readAloudState, setReadAloudState] = useState(ReadAloudStateEnum.None)
    const [srResult4Display, setSrResult4Display] = useState("") // Debug 用
    const [isWebAudioRecorderOn, setIsWebAudioRecorderOn] = useState(false) // 需不需要把 WebAudioRecoder init?
    const [, setUpdateDataTime] = useState(0)
    const [isDataPrerequisiteGotton, setIsDataPrerequisiteGotton] = useState(false)
    const [isSRPrerequisiteGotton, setIsSRPrerequisiteGotton] = useState(false)
    const [isInSRProcessing, setIsInSRProcessing] = useState(false)
    const [practiceEnable, setPracticeEnable] = useState(true) // 當不允許練習時 要顯示訊息給使用者
    // #endregion Init State

    // #region Init Ref
    let mrefScrollArea = useRef(null)
    let mrefWebAudioRecorderCore = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region Init Props Ref
    // #endregion Init Props Ref

    // #region Init Context Ref
    // History, Temp, 都是 Cached 在這裏
    let mobjLUCacheContext = useContext(LUCacheContext)
    console.log("mobjLUCacheContext: ", mobjLUCacheContext)
    // #endregion Init Context Ref

    // #region First Launc
    
    if (!mblnInitialized) {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)

        mstrLUKey4LUCachedContext = "LU" + props.LUInfo.LUCatSeqNo // 用於Cache LU資料時 指出此LU的Key
        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo

        mblnSRSupport = false
        if (window.gSession.App.InApp) {
            mblnSRSupport = true
        }
        else
        {
            if (window.gSession.App.BrowserType4LogTrace === GlobalLibs.BrowserTypeEnum.Chrome) {
                mblnSRSupport = true
            }
        }
        mobjWebAudioRecorder = null

        if (
            (typeof (window.gSession.Acc.Class) !== 'undefined') &&
            (window.gSession.Acc.Class !== null) &&
            (window.gSession.Acc.Class.length > 0) &&
            (window.gSession.Acc.CurrentClassIndex >= 0) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID !== null) &&
            (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)
        ) {
            mintClassID = parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID)
        }
        else
        {
            mintClassID = -1
        }

        console.log("init mintCurrentSentenceIndex to 0")   // 每次產生 TestSheet 就會被 reset
        mintCurrentSentenceIndex = 0
        mintTotalSentence = props.LUInfo.Sentence.length

        mobjArgs4UploadUserRecordedAudio = {
            "AccID": window.gSession.Acc.ID,
            "ClassID": mintClassID,
            "BookCategoryID": mstrBookCatID,
            "LessonID": props.LessonID,
            "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
            "TRSeqNo": props.LUInfo.Sentence[mintCurrentSentenceIndex].SeqNo,
            "TRPIndex": props.LUInfo.Sentence[mintCurrentSentenceIndex].ParagraphIdx,
            "DateType": 1,  // typo: DataType: 1? 1 DCP?
            "ContentType": "MFCW"
        }
        //:459,\"BookCategoryID\":\"03\",\"LessonID\":\"03001\",\"LUCatSeqNo\":28,\"ClassID\":\"57\",\"TRSeqNo\":0,\"TRPIndex\":2,\"DateType\":1,\"ContentType\":\"MFCW\"}"

        mblnInitialized = true
    }
    // #endregion First Launch

    // #region useEffec
    
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        // init, since need to get data from backend
        mrefPaintedMe.current()
        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mrefCleanUp.current()
        }
    }, [props.PathName])
    // #endregion useEffect

    // #region Painted Me
    
    // 程式進入 
    // 從 Backend 要資料
    // 需要 Open Loading Mask, 所以不要寫在 .Begin, 要寫在 useEffect
    function PaintedMe() {
        console.log(COMP_NAME + ".PaintedMe: ")
        RegisterAudioEvent()

        console.log("mobjLUCacheContext: ", mobjLUCacheContext)
        let objHistoryList = mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]
        console.log("objHistoryList: ", objHistoryList)

        if ((typeof (objHistoryList) === 'undefined') || (objHistoryList.LessonID !== props.LessonID)) {
            console.log("need to get Assignment History")
            GetPrerequisiteDataProcessBegin()
        }
        else
        {
            console.log("need Not to get Assignment History")
            GetPrerequisiteDataProcessEnd()
        }

        RegisterLanguageChangeHandler()
        RegisterGlossaryCallback()
        if (
            !window.gSession.App.InApp &&
            (window.gSession.App.BrowserType4LogTrace !== GlobalLibs.BrowserTypeEnum.Chrome)
        ) {
            // Web瀏覽器 且 非Chrome
            let strMessage = window.gAppUI.MSG_Alert_Msg_Google_SR_NotSupport
            let objAlertObject = {
                Header: null,
                Body: strMessage,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [{
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }]
            }

            ShowAlert(objAlertObject)
        }
    }

    function CleanUp() {
        console.log(COMP_NAME + ".CleanUp: ")

        // 避免離開這個 LU 還收到 SR Engine 的 Callback
        WebSpeech.RemoveEventHandlerRef()

        // 避免離開這個 LU 還收到 Audio Player 的 Callback
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.StopAudio()

        // 避免離開這個 LU 還收到 Web Audio Recoder 的 Callback
        if (mobjWebAudioRecorder !== null) {
            mobjWebAudioRecorder.UnregisterCallbackRef()
            mobjWebAudioRecorder = null
        }
        mrefWebAudioRecorderCore.current = null

        mblnInitialized = false

        mintCurrentSentenceIndex = 0

        UnregisterLanguageChangeHandler()
        UnregisterGlossaryCallback()
        mblnPracticeEnable = true
        if (window.gSession.App.InApp) {
            SRInApp.SRClose()
        }
        mstrPracticeDisableMessage = ""
    }
    // #endregion Painted Me

    // #region OnTapHandle
    
    function PreviousSentenceOnTapHandler() {
        console.log(COMP_NAME + ".PreviousSentenceOnTapHandler: ")
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (mintCurrentSentenceIndex > 0) {
            mintCurrentSentenceIndex--
        }

        ScrollToSentence(mintCurrentSentenceIndex)

        if (IsShowMicTipAgainFirst()) {
            // 如果目前有顯示 MicTipAgainFirst
            HideMicTipAgainFirst()
        }

        if (IsShowAudioTipFirst()) {
            // 如果目前有顯示 AudioTipFirst
            HideAudioTipFirst()
        }

        // Stop audio
        ResetPlayingAudioIndex()
        window.AudioLibs.StopAudio()

        setUpdateDataTime(new Date().getTime())
    }

    function NextSentenceOnTapHandler() {
        console.log(COMP_NAME + ".NextSentenceOnTapHandler: ")
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (mintCurrentSentenceIndex < mintTotalSentence - 1) {
            mintCurrentSentenceIndex++
        }

        ScrollToSentence(mintCurrentSentenceIndex)

        if (IsShowMicTipAgainFirst()) {
            // 如果目前有顯示 MicTipAgainFirst
            HideMicTipAgainFirst()
        }
        if (IsShowAudioTipFirst()) {
            // 如果目前有顯示 AudioTipFirst
            HideAudioTipFirst()
        }

        // 只要按Next按鈕後 就不再提示
        HideNextTipFirst()

        // Stop audio
        ResetPlayingAudioIndex()
        window.AudioLibs.StopAudio()

        setUpdateDataTime(new Date().getTime())
    }

    function SpeechRecognitionOnTapHandler() {
        console.log(COMP_NAME + ".SpeechRecognitionOnTapHandler: ")

        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        ScrollToSentence(mintCurrentSentenceIndex)

        mintSRResultErrorCount = 0  // richard add
        if (!isSRPrerequisiteGotton) {
            if (!window.gSession.App.InApp) {
                InitSRPrerequisiteProcessBegin()
            }
            else
            {
                InitSREngineBegin()
            }
        }
        else
        {
            SRProcessBegin()
        }

        if (IsShowMicTipAgainFirst()) {
            // 如果目前有顯示 MicTipAgainFirst
            HideMicTipAgainFirst()
        }
    }

    function HistoryOnTapHandler() {
        console.log(COMP_NAME + ".HistoryOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (IsShowMicTipAgainFirst()) {
            // 如果目前有顯示 MicTipAgainFirst
            HideMicTipAgainFirst()
        }

        if (IsShowNextTipFirst()) {
            // 如果目前有顯示 HideNextTipFirst
            HideNextTipFirst()
        }

        if (IsShowAudioTipFirst()) {
            // 如果目前有顯示 AudioTipFirst
            HideAudioTipFirst()
        }

        console.log("mobjLUCacheContext:", mobjLUCacheContext)
        console.log("mstrLUKey4LUCachedContext:", mstrLUKey4LUCachedContext)

        let objCallbackData = {
            "Action": "HistoryWindowOpen",
            "CallbackRef": HistoryWindowCallback,
            "LessonID": props.LessonID,
            "AssigementHistoryList": mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList,
            "AssignmentTempAns": mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext]
        }
        props.CallbackRef(objCallbackData)
    }

    function RetryOnTapHandler() {
        console.log(COMP_NAME + ".RetryOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        ScrollToSentence(0) // 點Retry後 自動Scroll到第一個Sentence

        if (IsShowMicTipAgainFirst()) {
            // 如果目前有顯示 MicTipAgainFirst
            HideMicTipAgainFirst()
        }

        if (IsShowNextTipFirst()) {
            // 如果目前有顯示 HideNextTipFirst
            HideNextTipFirst()
        }

        if (IsShowAudioTipFirst()) {
            // 如果目前有顯示 AudioTipFirst
            HideAudioTipFirst()
        }

        SetTestSheetObject(TestSheetModeEnum.New)
    }

    function SaveOnTapHandler() {
        console.log(COMP_NAME + ".SaveOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        ExecuteSaveAnswer()
    }

    function SubmitOnTapHandler() {
        console.log(COMP_NAME + ".SubmitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        ExecuteSubmitAnswer()
    }

    // #endregion OnTapHandler

    // #region Other Handle
    
    function LanguageOnChangeHandler() {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")
    }

    function PlayAudioEndHandler() {
        console.log(COMP_NAME + ".PlayAudioEndHandler: ", mintPlayAudioType)

        console.log("readAloudState: ", readAloudState)
        ResetPlayingAudioIndex()

        if (mintPlayAudioType === PlayAudioTypeEnum.VocabularyAudio) {
            setReadAloudState(ReadAloudStateEnum.QuestionAudioEnded)
            StartSRProcess()
        }
        else if (mintPlayAudioType === PlayAudioTypeEnum.VoiceNotDetected) {
            StartSRProcess()
        }

        setUpdateDataTime(new Date().getTime())
    }

    function PlayAudioCanPlayHandler() {
        console.log(COMP_NAME + ".PlayAudioCanPlayHandler: ")

        CloseLoadingMask()
    }
    // #endregion Other Handler

    // #region LoadingMask and Aler
    
    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    } // end of ShowAlert

    function OpenLoadingMask(LoadingMsg) {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    }

    function CloseLoadingMask() {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    }
    // #endregion LoadingMask and Alert

    // #region Toast
    // #endregion Toast

    // #region Component Callbac
    
    function HistoryWindowCallback(CallbackObj) {
        console.log(COMP_NAME + ".HistoryWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "HistoryWindowDetail") {
            console.log("HistoryWindowCallback.DetailOnTap")
            console.log("CallbackObj.AssignmentIndex:", CallbackObj.AssignmentIndex)
            mintIndex4HistoryItemToShow = parseInt(CallbackObj.AssignmentIndex)
            ScrollToSentence(0) // 點Detail後 自動Scroll到第一個Sentence
            SetTestSheetObject(TestSheetModeEnum.History)
        }
        if (CallbackObj.Action === "HistoryWindowLastSaved") {
            console.log("HistoryWindowCallback.LastSavedOnTap")
            // 點擊 HistoryWindow中的 LastSaved
            ScrollToSentence(0) // 點LastSaved後 自動Scroll到第一個Sentence
            SetTestSheetObject(TestSheetModeEnum.Temp)
            // setUpdateDataTime(new Date().getTime())
        }
    }

    function GlossaryWindowCallback(CallbackObj) {
        console.log(COMP_NAME + ".GlossaryWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowGlossary") {
            console.log("GlossaryWindowCallback.CloseShowGlossary")
            RegisterAudioEvent() // 因為開啟GlossaryWindow時 Audio Event被註冊過去 所以關閉GlossaryWindow時 要再註冊回此
        }
    }
    // #endregion Component Callback

    // #region Other Function
    

    // 判斷是否允許作答
    function CheckPraceticeEnable() {
        console.log(COMP_NAME + ".CheckPraceticeEnable")
        let blnEnablePractice = true
        let intAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)

        if (intAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT) {
            // 學生才會套用限制
            console.log("window.gSession.Acc.Class:", window.gSession.Acc.Class)
            console.log("window.gSession.Acc.CurrentClassIndex:", window.gSession.Acc.CurrentClassIndex)
            console.log("window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]:", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex])
            console.log("IsDCPSectionPracticeShow:", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow)

            console.log("mobjLUCacheContext:", mobjLUCacheContext)
            console.log("mstrLUKey4LUCachedContext:", mstrLUKey4LUCachedContext)
            console.log("mobjLUCacheContext.AssigementHistoryList:", mobjLUCacheContext.AssigementHistoryList)
            console.log("mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]: ", mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext])

            let strMsg = ""

            if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 0) {
                // Show Practice to Student 不允許Practice
                blnEnablePractice = false
                strMsg = window.gAppUI.MSG_Alert_Msg_BlockedInstructor
            }
            else if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 1) {
                // Show Practice to Student 有允許Practice
                let intAssignCount = 0 // 學生之前已Submit的次數
                if (
                    (typeof (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]) !== "undefined") &&
                    (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext] !== null) &&
                    (typeof (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList) !== 'undefined') &&
                    (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList !== null) &&
                    (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length > 0)
                ) {
                    console.log("mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length:", mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length)
                    intAssignCount = mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length
                }
                console.log("intAssignCount: ", intAssignCount)
                console.log("window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax: ", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax)

                // 學生身份
                // let strMsg = ""
                if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 0) {
                    // 老師關閉 Practice 或 Review
                    strMsg = window.gAppUI.MSG_Alert_Msg_BlockedInstructor
                    blnEnablePractice = false
                }
                else if (
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) <= 2) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) <= intAssignCount)
                ) {
                    // 作答次數 超過 設定值
                    if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) === 1) {
                        // 作答次數 超過 一次
                        console.log("Reach one time submission limit")
                        strMsg = window.gAppUI.MSG_Alert_Msg_TestedCountExceededOnce
                        blnEnablePractice = false
                    }
                    else
                    {
                        // 作答次數 超過 兩次
                        console.log("Reach two times submission limit")
                        strMsg = window.gAppUI.MSG_Alert_Msg_TestedCountExceededTwice
                        blnEnablePractice = false
                    }
                }
            }

            mblnPracticeEnable = blnEnablePractice
            mstrPracticeDisableMessage = strMsg
            console.log("mblnPracticeEnable: ", mblnPracticeEnable)
            console.log("mstrPracticeDisableMessage: ", mstrPracticeDisableMessage)
            setPracticeEnable(mblnPracticeEnable)
        }
        else
        {
            // 身份為 老師 或 個人 則不會有限制是否可Practice
            mblnPracticeEnable = true
            setPracticeEnable(mblnPracticeEnable)
        }
    }

    function RegisterAudioEvent() {
        console.log(COMP_NAME + ".RegisterAudioEvent")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioCanPlayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
    }

    function RegisterGlossaryCallback() {
        console.log(COMP_NAME + ".RegisterGlossaryCallback: ")
        // 因為ToolBarTopUnit點擊Glossary開啟後 會搶走AudioEnded, AudioCanPlay事件 所以如果LU有使用Audio Event 就必須在Glossary關閉時 需呼叫mobjCallerInfoForGlossaryWindow.CallbackRef 觸發 讓Audio Event再次註冊到LU
        let objCallbackData = {
            "Action": "RegisterGlossaryCallback",
            "CallbackRef": GlossaryWindowCallback
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterGlossaryCallback() {
        console.log(COMP_NAME + ".UnregisterGlossaryCallback: ")
        let objCallbackData = {
            "Action": "UnregisterGlossaryCallback"
        }
        props.CallbackRef(objCallbackData)
    }

    function ResetPlayingAudioIndex() {
        console.log(COMP_NAME + ".ResetPlayingAudioIndex: ")
        // Reset
        mobjPlayingAudioIndex.SentenceIndex = INDEX_NONE
        mobjPlayingAudioIndex.AudioType = AudioType.None
    }

    function SetPlayingAudioIndex(SentenceIndex, AudioType) {
        console.log(COMP_NAME + ".SetPlayingAudioIndex: ", SentenceIndex, AudioType)

        mobjPlayingAudioIndex.SentenceIndex = SentenceIndex
        mobjPlayingAudioIndex.AudioType = AudioType
    }

    function RegisterLanguageChangeHandler() {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterLanguageChangeHandler() {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    }

    function GetPrerequisiteDataProcessBegin() {
        console.log(COMP_NAME + ".GetPrerequisiteDataProcessBegin: ")

        // 2 Steps:
        // 1. History
        // 2. Temp Answer List
        GetAssignmentAssignAnswer()
    }

    function GetPrerequisiteDataProcessEnd() {
        console.log(COMP_NAME + ".GetPrerequisiteDataProcessEnd: ")

        console.log("mobjLUCacheContext.AssigementHistoryList: ", mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext])
        console.log("mobjLUCacheContext.AssignmentTempAnsList: ", mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext])

        let enumTestSheeMode = TestSheetModeEnum.New
        if (
            (typeof (mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext]) !== "undefined") &&
            (mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext] !== null) &&
            (mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].TestedTime !== null)
        ) {
            enumTestSheeMode = TestSheetModeEnum.Temp
        }
        else if (
            (typeof (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]) !== "undefined") &&
            (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext] !== null) &&
            (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length > 0)
        ) {
            enumTestSheeMode = TestSheetModeEnum.History
            mintIndex4HistoryItemToShow = 0
        }

        SetTestSheetObject(enumTestSheeMode)

        CheckPraceticeEnable()

        setIsDataPrerequisiteGotton(true)
    }

    function SetTestSheetObject(TestSheetMode) {
        console.log(COMP_NAME + ".SetTestSheetObject: ", TestSheetMode)

        console.log("mobjLUCacheContext.AssigementHistoryList: ", mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext])
        console.log("mobjLUCacheContext.AssignmentTempAnsList: ", mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext])

        let arrSentence = props.LUInfo.Sentence
        console.log("arrSentence: ", arrSentence)

        // {
        //     "ParagraphIdx": 0,
        //     "SeqNo": 0,
        //     "AudioFN": "01001_illustrationtext_01.mp3",
        //     "Major": "你好！",
        //     "Minor": "你好！",
        //     "TextWithoutSymbol": "你好",
        //     "ReadAs": "",
        //     "Character": {
        //         "ID": "2",
        //         "MajorName": "李明",
        //         "MinorName": "李明"
        //     }
        // }

        console.log("set mintCurrentSentenceIndex to 0")
        mintCurrentSentenceIndex = 0 // Temp 的話要看第一筆 -1 的
        if (
            !window.gSession.App.InApp &&
            (window.gSession.App.BrowserType4LogTrace !== GlobalLibs.BrowserTypeEnum.Chrome)
        ) {
            // 如果Web瀏覽器 不是Chrome時 則不提供SR功能 只顯示
            mobjTestSheet.Mode = TestSheetModeEnum.History
        }
        else
        {
            mobjTestSheet.Mode = TestSheetMode
        }
        mobjTestSheet.Score = SCROE_DEFAULT
        mobjTestSheet.Dirty = false
        mobjTestSheet.Sentence = []
        let arrTempAnswerList = []
        let objHistoryAnswerSheet = null
        let arrHistoryAnswerList = []
        if (TestSheetMode === TestSheetModeEnum.Temp) {
            arrTempAnswerList = mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].AnswerList
        }
        if (TestSheetMode === TestSheetModeEnum.History) {
            objHistoryAnswerSheet = mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList[mintIndex4HistoryItemToShow]
            arrHistoryAnswerList = objHistoryAnswerSheet.AnswerList
            mobjTestSheet.Score = parseFloat(objHistoryAnswerSheet.Score)
            // mobjTestSheet.Cached = objHistoryAnswerSheet.Cached
        }

        arrSentence.forEach((Sentence, Index) => {

            let objQuestion = {
                TRSeqNo: Sentence.SeqNo,
                TRPIndex: Sentence.ParagraphIdx,
                AudioUrl: window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Audio, Sentence.AudioFN),
                Text: (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? Sentence.Major : Sentence.Minor,
                Character: {
                    ID: Sentence.Character.ID,
                    Name: (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? Sentence.Character.MajorName : Sentence.Character.MinorName
                }
            }
            let objAnswer = null
            if (TestSheetMode === TestSheetModeEnum.Temp) {
                let objTempAnswer = arrTempAnswerList[Index]
                console.log("objTempAnswer: ", objTempAnswer)

                objAnswer = {
                    AnswerID: objTempAnswer.AnswerID,
                    TRAudioFN: objTempAnswer.TRAudioFN,
                    // AudioUrl: strAudioUrl, //(objTempAnswer.TRAudioFN !== null) ? window.Globals.GetUserNewAssignmentTmpUrl(mstrBookCatID, props.LessonID, props.LUInfo.LUCatSeqNo, window.gSession.Acc.ID, objTempAnswer.TRAudioFN, objTempAnswer.AnswerID) : null,
                    AudioUrl: (objTempAnswer.TRAudioFN !== null) ? window.Globals.GetUserNewAssignmentTmpUrl(mstrBookCatID, props.LessonID, props.LUInfo.LUCatSeqNo, window.gSession.Acc.ID, objTempAnswer.TRAudioFN, objTempAnswer.AnswerID) : null,
                    UserAnswer: GetUserAnswerObjectFromBackendObject(objTempAnswer.TRAnswer),
                    Score: parseFloat(objTempAnswer.TRScore)
                }

                console.log("mintCurrentSentenceIndex: ", mintCurrentSentenceIndex)
                console.log("objTempAnswer.TRScore: ", objTempAnswer.TRScore)
                console.log("Index: ", Index)
                if ((mintCurrentSentenceIndex === 0) && (parseFloat(objTempAnswer.TRScore) < 0)) {
                    // 目前第哪一題
                    mintCurrentSentenceIndex = Index
                }
            }
            else if (TestSheetMode === TestSheetModeEnum.History) {
                let objTempAnswer = arrHistoryAnswerList[Index]
                console.log("objTempAnswer: ", objTempAnswer)
                let strAudioUrl = null
                if (objTempAnswer.TRAudioFN !== null) {
                    if (objTempAnswer.TRAudioFN.indexOf("base64") !== -1) {
                        // base64 format
                        strAudioUrl = objTempAnswer.TRAudioFN
                    }
                    else
                    {
                        // console.log("mobjTestSheet: ", mobjTestSheet)
                        // console.log("objTempAnswer: ", objTempAnswer)
                        // if (mobjTestSheet.Cached === true)
                        // {
                        //     console.log("yyyyyyyyyyyyyyyyy: ")
                        //     // marrAnswerList4Submit[Index]
                        //     strAudioUrl = objTempAnswer.AudioUrl
                        //     // window.Globals.GetUserNewAssignmentTmpUrl(mstrBookCatID, props.LessonID, props.LUInfo.LUCatSeqNo, window.gSession.Acc.ID, objTempAnswer.TRAudioFN, objTempAnswer.AnswerID)                            
                        // }
                        // else
                        // {
                        strAudioUrl = window.Globals.GetUserNewAssignmentUrl(objHistoryAnswerSheet.AssignID, objTempAnswer.TRAudioFN)
                        // }
                    }
                }

                objAnswer = {
                    AnswerID: objTempAnswer.AnswerID,
                    TRAudioFN: objTempAnswer.TRAudioFN,
                    AudioUrl: strAudioUrl, //(objTempAnswer.TRAudioFN !== null) ? window.Globals.GetUserNewAssignmentUrl(objHistoryAnswerSheet.AssignID, objTempAnswer.TRAudioFN) : null,
                    UserAnswer: GetUserAnswerObjectFromBackendObject(objTempAnswer.TRAnswer),
                    Score: parseFloat(objTempAnswer.TRScore)
                }
            }
            else if (TestSheetMode === TestSheetModeEnum.New) {
                objAnswer = {
                    AnswerID: -1,
                    TRAudioFN: null,
                    AudioUrl: null,
                    UserAnswer: {
                        CharScore: null,
                        IsPassed: false
                    },
                    Score: SCROE_DEFAULT
                }
            }

            let objSentence = {
                Question: objQuestion,
                Answer: objAnswer
            }

            mobjTestSheet.Sentence.push(objSentence)
        })

        setUpdateDataTime(new Date().getTime())
        console.log("mobjTestSheet: ", mobjTestSheet)
    }

    function GetUserAnswerObjectFromBackendObject(BackendAnswer) {
        console.log(COMP_NAME + ".GetUserAnswerObjectFromBackendObject: ", BackendAnswer)
        // {"CharScore":[],"ResultHtml":"<span class='compPracticeFluency_lblAnswerSuccess'>\u4f60\u597d\uff01</span>","IsPassed":true}

        let objBackendAnswer = JSON.parse(BackendAnswer)
        let objUserAnswer = {
            CharScore: [].concat(objBackendAnswer.CharScore),
            IsPassed: objBackendAnswer.IsPassed
        }

        console.log("objUserAnswer: ", objUserAnswer)
        return objUserAnswer
    }

    function InitSRPrerequisiteProcessBegin() {
        console.log(COMP_NAME + ".InitSRPrerequisiteProcessBegin: ")

        // 1. WebAudioRecorder
        // 2. SREngine
        // 3. Pinyin Files
        // 都完成，或是有遇到 Init Error
        // 就進入 InitSRPrerequisiteProcess End

        setReadAloudState(ReadAloudStateEnum.Initing)

        // 1. WebAudioRecoder
        InitWebAudioRecorderBegin()
    }

    function SRProcessBegin() {
        console.log(COMP_NAME + ".SRProcessBegin: ")

        setIsInSRProcessing(true)

        PlaySentenceAudioAndStartSR()
    }

    function SRProcessEnd() {
        console.log(COMP_NAME + ".SRProcessBegin: ")

        setIsInSRProcessing(false)
    }

    function UploadNewAssignmentResult() {
        console.log(COMP_NAME + ".UploadNewAssignmentResult: ")
        let objRetryFuncRef = UploadNewAssignmentResult
        if (!window.navigator.onLine) {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UploadNewAssignmentResultCallback

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_UploadNewAssignmentResult)

            let objCallData = {
                "Func": "UploadNewAssignmentResult",
                "BookCategoryID": mstrBookCatID,
                "LessonID": props.LessonID,
                "ClassID": mintClassID,
                "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
                "Answer": JSON.stringify(marrAnswerList4Submit),
                "Score": mfltAvgScore4Submit
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                }
                )
        }
    }

    function UploadNewAssignmentResultCallback(Return) {
        console.log(COMP_NAME + ".UploadNewAssignmentResultCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UploadAssignmentTmpResult_No
        let strErrorTitle = window.gAppUI.ERR_UploadAssignmentResult_Title
        let strErrMsg = window.gAppUI.ERR_UploadAssignmentResult_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS) {
            switch (Return.CalledErrNo) {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UploadNewAssignmentResultCallback: ErrNo: ", Return.ErrNo)
            console.log("UploadNewAssignmentResultCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("UploadNewAssignmentResultCallback Return.Data", Return.Data)

            UploadNewAssignmentResultAfterProcess(Return.Data)
        }
    }

    function UploadNewAssignmentResultAfterProcess(ReturnData) {
        console.log(COMP_NAME + ".UploadNewAssignmentResultAfterProcess: ", ReturnData)

        UpdateCacheSinceSubmit(ReturnData)
        mintIndex4HistoryItemToShow = 0
        SetTestSheetObject(TestSheetModeEnum.History)

        CheckPraceticeEnable()
    }


    function UpdateCacheSinceSubmit(DataFromSubmit) {
        console.log(COMP_NAME + ".UpdateCacheSinceSubmit: ", DataFromSubmit)

        let objTestTime = new Date()
        // let arrAnswerList = []
        // marrAnswerList4Submit.forEach(Answer => {
        //     let objCachedAnswer = {
        //         TRAnswer: Answer.TRAnswer,
        //         TRAudioFN: Answer.TRAudioFN4CacheUpdate,
        //         TRScore: Answer.TRScore
        //     }

        //     arrAnswerList.push(objCachedAnswer)
        // })
        let objNewAssign = {
            // Cached: true,
            // AnswerList: arrAnswerList,
            AnswerList: DataFromSubmit.AnswerList,
            AssignID: DataFromSubmit.AssignID,
            Score: parseFloat(DataFromSubmit.Score),
            TestedTime: objTestTime.ToBCUTCString()
        }

        // 更新 History 資料
        console.log("objNewAssign: ", objNewAssign)
        mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.unshift(objNewAssign)

        // 清除 Temp 資料
        mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].AnswerList = []
        mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].TestedTime = null
    }

    function UpdateCacheSinceSaveTemp(DataFromSaveTemp) {
        console.log(COMP_NAME + ".UpdateCacheSinceSaveTemp: ", DataFromSaveTemp)

        mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext] = DataFromSaveTemp
    }

    /*===========================================
    summary: 點選 GoogleClassroom 元件
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler() 
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置

        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler

    function GetSentenceScore(ScoreWithPoint) {
        console.log(COMP_NAME + ".GetSentenceScore: ", ScoreWithPoint)

        let intScore = parseInt(Math.round(parseFloat(ScoreWithPoint) * 100)) // 單題的辨識分數是小數點 轉成 百分制 e.g. 從 0.53125 轉成 53
        console.log("intScore: ", intScore)

        let strScore = ""
        if (intScore >= 0) {
            strScore = intScore.toString()
        }
        return strScore
    }

    function IsMainCharacter(MainCharacterID, CurrentCharacterID) {
        console.log(COMP_NAME + ".IsMainCharacter: ", MainCharacterID, CurrentCharacterID)
        let blnIsMainCharacter = false
        if (MainCharacterID === CurrentCharacterID) {
            blnIsMainCharacter = true
        }
        return blnIsMainCharacter
    }

    function GetLeftCharacterName(MainCharacterID, CurrentCharacterID, Name) {
        let strName = ""
        if (IsMainCharacter(MainCharacterID, CurrentCharacterID)) {
            strName = Name
        }
        return strName
    }

    function GetRightCharacterName(MainCharacterID, CurrentCharacterID, Name) {
        let strName = ""
        if (!IsMainCharacter(MainCharacterID, CurrentCharacterID)) {
            strName = Name
        }
        return strName
    }

    function ExecuteSaveAnswer() {
        console.log(COMP_NAME + ".ExecuteSaveAnswer: ")

        if (!mobjTestSheet.Dirty) {
            return
        }
        marrAnswerList4Save = []
        mobjTestSheet.Sentence.forEach((Sentence) => {
            console.log("Sentence: ", Sentence)
            let strAudioUrl = ""
            if ((Sentence.Answer.AudioUrl !== null) && (Sentence.Answer.AudioUrl.indexOf("base64") === -1)) {
                strAudioUrl = Sentence.Answer.TRAudioFN
            }
            let objAnswer = {
                "TRSeqNo": Sentence.Question.TRSeqNo,
                "TRPIndex": Sentence.Question.TRPIndex,
                "TRScore": Sentence.Answer.Score,
                "TRAnswer": JSON.stringify(Sentence.Answer.UserAnswer),
                "TRAudioFN": strAudioUrl
            }

            marrAnswerList4Save.push(objAnswer)
        })
        console.log("marrAnswerList4Save: ", marrAnswerList4Save)

        UploadNewAssignmentTmpResult()
    }

    function IsTestSheetFinished(TestSheet) {
        console.log(COMP_NAME + ".IsTestSheetFinished: ", TestSheet)

        // mobjTestSheet
        // TestSheet.Sentence[i].Answer.Score
        if (TestSheet.Sentence.length > 0) {
            let objFoundNotYet = TestSheet.Sentence.find(Sentence => parseFloat(Sentence.Answer.Score) < 0)

            if (typeof (objFoundNotYet) !== 'undefined') {
                // found -1
                return false
            }
            else
            {
                return true
            }

        }
        else
        {
            return false
        }
    }

    function ExecuteSubmitAnswer() {
        console.log(COMP_NAME + ".ExecuteSubmitAnswer: ")

        marrAnswerList4Submit = []
        mfltAvgScore4Submit = 0

        let fltTotalScore = 0 // 有作答的總分

        mobjTestSheet.Sentence.forEach((Sentence) => {
            console.log("Sentence: ", Sentence)
            let strAudioUrl = ""
            if ((Sentence.Answer.AudioUrl !== null) && (Sentence.Answer.AudioUrl.indexOf("base64") === -1)) {
                strAudioUrl = Sentence.Answer.TRAudioFN
            }
            let objAnswer = {
                "TRSeqNo": Sentence.Question.TRSeqNo,
                "TRPIndex": Sentence.Question.TRPIndex,
                "TRScore": Sentence.Answer.Score,
                "TRAnswer": JSON.stringify(Sentence.Answer.UserAnswer),
                "TRAudioFN": strAudioUrl//,
                // "TRAudioFN4CacheUpdate": Sentence.Answer.AudioUrl
            }

            marrAnswerList4Submit.push(objAnswer)

            if (Sentence.Answer.Score !== SCROE_DEFAULT) {
                // 有作答
                fltTotalScore += Sentence.Answer.Score
            }
        })

        // console.log("fltTotalScore: ", fltTotalScore)
        // console.log("mobjTestSheet.Sentence.length: ", mobjTestSheet.Sentence.length)
        mfltAvgScore4Submit = Math.round((fltTotalScore / mobjTestSheet.Sentence.length) * 100) // 有作答的總分的平均 以百分制顯示

        console.log("marrAnswerList4Submit: ", marrAnswerList4Submit)
        console.log("mfltAvgScore4Submit: ", mfltAvgScore4Submit)

        UploadNewAssignmentResult()
    }

    function ScrollToSentence(SentenceIndex) {
        console.log(COMP_NAME + ".ScrollToSentence.SentenceIndex: ", SentenceIndex)

        if (mrefScrollArea.current !== null) {
            let intScrollHeight = mrefScrollArea.current.scrollHeight; // scrollHeight Ref: https://www.w3schools.com/jsref/prop_element_scrollheight.asp
            let intScrollWidth = mrefScrollArea.current.scrollWidth; // scrollWidth
            let intScrollLeft = mrefScrollArea.current.scrollLeft; // scrollLeft
            let intScrollTop = mrefScrollArea.current.scrollTop; // scrollTop

            console.log("intScrollHeight:", intScrollHeight)
            console.log("intScrollWidth:", intScrollWidth)
            console.log("intScrollLeft:", intScrollLeft)
            console.log("intScrollTop:", intScrollTop)

            // let intClientHeight = mrefScrollArea.current.clientHeight; // .divScrollArea 的高度 // clientHeight Ref: https://www.w3schools.com/jsref/prop_element_clientheight.asp
            // let intClientWidth = mrefScrollArea.current.clientWidth; // clientWidth
            // let intClientTop = mrefScrollArea.current.clientTop; // clientTop
            // let intClientLeft = mrefScrollArea.current.clientLeft; // clientLeft

            // console.log("intClientHeight:", intClientHeight)
            // console.log("intClientWidth:", intClientWidth)
            // console.log("intClientTop:", intClientTop)
            // console.log("intClientLeft:", intClientLeft)

            // let intScrollTop = mrefScrollArea.current.scrollTop;
            // let intClientHeight = mrefScrollArea.current.clientHeight;
            // let intScrollHeight = mrefScrollArea.current.scrollHeight;

            let arrMenuLessonElements = mrefScrollArea.current.querySelectorAll("[name='nameScrollSentence']")
            console.log("arrMenuLessonElements: ", arrMenuLessonElements)
            if (arrMenuLessonElements.length > 0) {
                let intOffsetTop = arrMenuLessonElements[SentenceIndex].offsetTop
                console.log("ScrollToSentence: intOffsetTop:", intOffsetTop)
                GlobalLibs.ExecuteScrollTo(mrefScrollArea.current, intOffsetTop, 0, 300)
            }
        }
        else
        {
            console.log("mrefScrollArea不存在 不應該出現")
        }
    }

    function GetTextYourScore() {
        console.log(COMP_NAME + ".GetTextYourScore: ", mobjTestSheet)
        let strScore = window.gAppUI.LBL_NotScore
        if (mobjTestSheet.Mode === TestSheetModeEnum.History) {
            if (
                (typeof (mobjTestSheet.Score) !== "undefined") &&
                (mobjTestSheet.Score !== null) &&
                (mobjTestSheet.Score !== SCROE_DEFAULT)
            ) {
                // let fltScoreWithPoint = parseFloat(mobjTestSheet.Score)
                // strScore = Math.round(fltScoreWithPoint * 100).toString()
                strScore = mobjTestSheet.Score.toString()
                console.log("strScore:", strScore)
            }
        }
        return strScore
    }

    function GetTextTapToStartRecording() {
        let strMessage = ""
        if (!isInSRProcessing) {
            strMessage = window.gAppUI.LBL_TapToStartRecording
        }
        return strMessage
    }

    function IsShowMicTipAgainFirst() {
        console.log(COMP_NAME + ".IsShowMicTipAgainFirst: ")

        console.log("LocalStorageLibs.GetAccLSElement('IsMicTipAgainFirst'): ", LocalStorageLibs.GetAccLSElement("IsMicTipAgainFirst"))
        console.log("mobjTipFlags.IsMicTipAgainFirst: ", mobjTipFlags.IsMicTipAgainFirst)
        console.log("readAloudState: ", readAloudState)

        let blnShow = false
        if (
            LocalStorageLibs.GetAccLSElement("IsMicTipAgainFirst") && // 顯示
            mobjTipFlags.IsMicTipAgainFirst && // 進入此LU後 第一次有SR結果
            (readAloudState === ReadAloudStateEnum.ResultProcessed) && // 有SR結果
            (!mobjAnswer.IsPassed) // SR結果 不及格
        ) {
            blnShow = true
        }
        return blnShow
    }

    function HideMicTipAgainFirst() {
        console.log(COMP_NAME + ".HideMicTipAgainFirst: ")
        LocalStorageLibs.SetAccLSElement("IsMicTipAgainFirst", false)
        mobjTipFlags.IsMicTipAgainFirst = false
    }

    function IsShowNextTipFirst() {
        console.log(COMP_NAME + ".IsShowNextTipFirst: ")

        console.log("LocalStorageLibs.GetAccLSElement('IsNextTipFirst'): ", LocalStorageLibs.GetAccLSElement("IsNextTipFirst"))
        console.log("mobjTipFlags.IsNextTipFirst: ", mobjTipFlags.IsNextTipFirst)
        console.log("readAloudState: ", readAloudState)

        let blnShow = false
        if (
            LocalStorageLibs.GetAccLSElement("IsNextTipFirst") && // 顯示
            mobjTipFlags.IsNextTipFirst && // 進入此LU後 第一次SR通過
            (readAloudState === ReadAloudStateEnum.ResultProcessed) && // 有SR結果
            (mobjAnswer.IsPassed) // SR結果及格
        ) {
            blnShow = true
        }
        return blnShow
    }

    function HideNextTipFirst() {
        console.log(COMP_NAME + ".HideNextTipFirst: ")
        LocalStorageLibs.SetAccLSElement("IsNextTipFirst", false)
        mobjTipFlags.IsNextTipFirst = false
    }

    function IsShowAudioTipFirst() {
        console.log(COMP_NAME + ".IsShowAudioTipFirst: ")

        console.log("LocalStorageLibs.GetAccLSElement('IsAudioTipFirst'): ", LocalStorageLibs.GetAccLSElement("IsAudioTipFirst"))
        console.log("mobjTipFlags.IsAudioTipFirst: ", mobjTipFlags.IsAudioTipFirst)
        console.log("readAloudState: ", readAloudState)

        let blnShow = false
        if (
            LocalStorageLibs.GetAccLSElement("IsAudioTipFirst") && // 顯示
            mobjTipFlags.IsAudioTipFirst && // 進入此LU後 第一次有SR結果
            (readAloudState === ReadAloudStateEnum.ResultProcessed) // 有SR結果
        ) {
            blnShow = true
        }
        return blnShow
    }

    function HideAudioTipFirst() {
        console.log(COMP_NAME + ".HideAudioTipFirst: ")
        LocalStorageLibs.SetAccLSElement("IsAudioTipFirst", false)
        mobjTipFlags.IsAudioTipFirst = false
    }

    // #endregion Other Functions

    // #region Get ClassName and Styl
    
    function GetClsCellTop(SentenceIndex, PracticeEnable) {
        console.log(COMP_NAME + ".GetClsCellTop: ", SentenceIndex, mintCurrentSentenceIndex, PracticeEnable)

        let objCls = null

        if (SentenceIndex === mintCurrentSentenceIndex) {
            if (PracticeEnable) {
                // 目前是指到這一個Sentence
                objCls = cssPracticeFluency.divCellTopAreaCurrentSentence
            }
            else
            {
                objCls = cssPracticeFluency.divCellTopArea
            }
        }
        else
        {
            objCls = cssPracticeFluency.divCellTopArea
        }

        return objCls
    }

    function GetClsCellBottom(Answer) {
        console.log(COMP_NAME + ".GetClsCellBottom", Answer)

        let objCls = null

        if (
            (Answer !== null) &&
            (parseFloat(Answer.Score) >= 0)
        ) {
            objCls = cssPracticeFluency.divCellBottomArea
        }
        else
        {
            objCls = cssPracticeFluency.divCellBottomAreaWithoutAnswer
        }
        return objCls
    }

    function GetClsSentenceScore(ScoreWithPoint) {
        console.log(COMP_NAME + ".GetClsSentenceScore: ", ScoreWithPoint)

        // let intScore = parseInt(Score)
        let intScore = parseInt(Math.round(parseFloat(ScoreWithPoint) * 100)) // 單題的辨識分數是小數點 轉成 百分制 e.g. 從 0.53125 轉成 53
        console.log("intScore: ", intScore)

        let objCls = null
        let intPassScore = 60
        if (intScore >= intPassScore) {
            objCls = cssPracticeFluency.divUserScoreCirclePass
        }
        else if (
            intScore >= 0 &&
            intScore < intPassScore
        ) {
            objCls = cssPracticeFluency.divUserScoreCircleFail
        }
        return objCls
    }

    function GetClsUserVoiceButton(AudioUrl, SentenceIndex) {
        console.log(COMP_NAME + ".GetClsUserVoiceButton: ", AudioUrl.length, SentenceIndex)

        let objCls = null
        if (
            (mobjPlayingAudioIndex.SentenceIndex === SentenceIndex) &&
            (mobjPlayingAudioIndex.AudioType === AudioType.StudentVoice)
        ) {
            // 目前正在播此音檔
            objCls = cssPracticeFluency.divUserVoiceButtonDisable
        }
        else if (!isInSRProcessing) {
            if (
                (AudioUrl !== null) &&
                (AudioUrl !== "")
            ) {
                objCls = cssPracticeFluency.divUserVoiceButton
            }
        }
        else
        {
            objCls = cssPracticeFluency.divUserVoiceButtonDisable
        }

        return objCls
    }

    function GetClsLeftAvator(MainCharacterID, CurrentCharacterID) {
        let objCls = cssPracticeFluency.divHidden
        if (IsMainCharacter(MainCharacterID, CurrentCharacterID)) {
            objCls = cssPracticeFluency.divLeftCharacterAvator
        }
        return objCls
    }

    function GetClsRightAvator(MainCharacterID, CurrentCharacterID) {
        let objCls = cssPracticeFluency.divHidden
        if (!IsMainCharacter(MainCharacterID, CurrentCharacterID)) {
            objCls = cssPracticeFluency.divRightCharacterAvator
        }
        return objCls
    }

    function GetClsSentenceAudioButton(AudioUrl, SentenceIndex) {
        console.log(COMP_NAME + ".GetClsSentenceAudioButton: ", AudioUrl)

        let objCls = null
        if (
            (mobjPlayingAudioIndex.SentenceIndex === SentenceIndex) &&
            (mobjPlayingAudioIndex.AudioType === AudioType.QuestionAudio)
        ) {
            // 目前正在播此音檔
            objCls = cssPracticeFluency.divSentenceAudioButtonDisable
        }
        else if (!isInSRProcessing) {
            if (
                (AudioUrl !== null) &&
                (AudioUrl !== "")
            ) {
                objCls = cssPracticeFluency.divSentenceAudioButton
            }
        }
        else
        {
            objCls = cssPracticeFluency.divSentenceAudioButtonDisable
        }

        return objCls
    }

    function GetClsSpeechRecognitionButtonArea(PracticeEnable) {
        console.log(COMP_NAME + ".GetClsSpeechRecognitionButtonArea: ", readAloudState)

        let objCls = cssPracticeFluency.divSRDisable
        switch (readAloudState) {
            case ReadAloudStateEnum.None:
            case ReadAloudStateEnum.Inited:
            case ReadAloudStateEnum.ResultProcessed:
            case ReadAloudStateEnum.QuestionAudioEnded:
            case ReadAloudStateEnum.SRErrorProcessed:
            case ReadAloudStateEnum.InitedSRFailed:
            case ReadAloudStateEnum.InitedWebAudioRecorderFailed:
                objCls = cssPracticeFluency.divSRStart
                break
            case ReadAloudStateEnum.Initing:
            case ReadAloudStateEnum.QuestionAudioPlaying:
                objCls = cssPracticeFluency.divSRDisable
                break
            case ReadAloudStateEnum.UserRecording:
                objCls = cssPracticeFluency.divSRRecording
                break
            // case ReadAloudStateEnum.SRErrorProcessing:
            //     objCls = cssPracticeFluency.divSRDisable
            //     break
            default:
                objCls = cssPracticeFluency.divSRDisable
                break
        }

        if (!PracticeEnable) {
            objCls = cssPracticeFluency.divSRDisable
        }

        return objCls
    }

    function GetClsUpBottom(PracticeEnable) {
        console.log(COMP_NAME + ".GetClsUpBottom", PracticeEnable)

        let objCls = null
        if (
            (mintCurrentSentenceIndex === 0) ||
            isInSRProcessing
        ) {
            objCls = cssPracticeFluency.divPrevSentenceButtonDisable
        }
        else
        {
            if (PracticeEnable) {
                objCls = cssPracticeFluency.divPrevSentenceButton
            }
            else
            {
                objCls = cssPracticeFluency.divPrevSentenceButtonDisable
            }
        }
        return objCls
    }

    function GetClsDownBottom(PracticeEnable) {
        console.log(COMP_NAME + ".GetClsDownBottom: ", PracticeEnable)

        let objCls = null
        if (
            (mintCurrentSentenceIndex === mintTotalSentence - 1) ||
            isInSRProcessing
        ) {
            objCls = cssPracticeFluency.divNextSentenceButtonDisable
        }
        else
        {
            if (PracticeEnable) {
                objCls = cssPracticeFluency.divNextSentenceButton
            }
            else
            {
                objCls = cssPracticeFluency.divNextSentenceButtonDisable
            }
        }
        return objCls
    }

    function GetClsButtonRetry(PracticeEnable) {
        console.log(COMP_NAME + ".GetClsButtonRetry: ", mobjTestSheet, PracticeEnable)
        let objCls = null

        if (
            !isInSRProcessing &&
            (mobjTestSheet.Mode === TestSheetModeEnum.History)
        ) {
            if (
                !window.gSession.App.InApp &&
                (window.gSession.App.BrowserType4LogTrace !== GlobalLibs.BrowserTypeEnum.Chrome)
            ) {
                // Web瀏覽器 且 非Chrome
                objCls = cssPracticeFluency.divTitleRightButtonAreaDisable
            }
            else
            {
                if (PracticeEnable) {
                    objCls = cssPracticeFluency.divTitleRightButtonArea
                }
                else
                {
                    objCls = cssPracticeFluency.divTitleRightButtonAreaDisable
                }
            }
        }
        else
        {
            objCls = cssPracticeFluency.divHidden
        }

        return objCls
    }

    function GetClsButtonSubmit(PracticeEnable) {
        console.log(COMP_NAME + ".GetClsButtonSubmit: ", mobjTestSheet, PracticeEnable)

        let blnIsTestSheetFinished = IsTestSheetFinished(mobjTestSheet)
        console.log("blnIsTestSheetFinished:", blnIsTestSheetFinished)
        console.log("mobjTestSheet.Mode:", mobjTestSheet.Mode)
        console.log("mobjTestSheet.Dirty:", mobjTestSheet.Dirty)
        let objCls = null

        if (mobjTestSheet.Mode === TestSheetModeEnum.History) {
            objCls = cssPracticeFluency.divHidden
        }
        else
        {
            // mobjTestSheet.Dirty || // 剛剛有錄過新的內容
            // mobjTestSheet.Mode === TestSheetModeEnum.Temp || // 從History點入此未完成的
            if (
                !isInSRProcessing &&
                blnIsTestSheetFinished // 都已完成
            ) {
                if (PracticeEnable) {
                    objCls = cssPracticeFluency.divTitleRightButtonArea
                }
                else
                {
                    objCls = cssPracticeFluency.divTitleRightButtonAreaDisable
                }
            }
            else
            {
                objCls = cssPracticeFluency.divTitleRightButtonAreaDisable
            }
        }
        return objCls
    }

    function GetClsButtonHistory(AssignmentTempAns, AssigementHistoryItem) {
        console.log(COMP_NAME + ".GetClsButtonHistory")
        let objCls = cssPracticeFluency.divTitleRightButtonAreaDisable
        if (
            !isInSRProcessing
            &&
            (
                (
                    (typeof (AssignmentTempAns) !== "undefined") &&
                    (AssignmentTempAns !== null) &&
                    (typeof (AssignmentTempAns.TestedTime) !== "undefined") &&
                    (AssignmentTempAns.TestedTime !== null)
                ) // 有 部分完成的答案
                ||
                (
                    (typeof (AssigementHistoryItem) !== "undefined") &&
                    (AssigementHistoryItem !== null) &&
                    (typeof (AssigementHistoryItem.NewAssignList) !== "undefined") &&
                    (AssigementHistoryItem.NewAssignList.length > 0)
                ) // 有 答題完成的歷史答案
            )
        ) {
            objCls = cssPracticeFluency.divTitleRightButtonArea
        }
        return objCls
    }

    function GetClsBarOnTheLeftOfSave(TestSheetMode) {
        console.log(COMP_NAME + ".GetClsBarOnTheLeftOfSave: ", mobjTestSheet)
        let objCls = null
        if (TestSheetMode === TestSheetModeEnum.History) {
            objCls = cssPracticeFluency.divHidden
        }
        else
        {
            objCls = cssPracticeFluency.divTitleRightBar
        }
        return objCls
    }

    function GetClsButtonSave() {
        console.log(COMP_NAME + ".GetClsButtonSave: ", mobjTestSheet)
        let objCls = null

        if (mobjTestSheet.Mode === TestSheetModeEnum.History) {
            objCls = cssPracticeFluency.divHidden
        }
        else
        {
            if (
                !isInSRProcessing &&
                mobjTestSheet.Dirty
            ) {
                objCls = cssPracticeFluency.divTitleRightButtonArea
            }
            else
            {
                objCls = cssPracticeFluency.divTitleRightButtonAreaDisable
            }
        }
        return objCls
    }

    function GetClsTipMicTipArea() {
        console.log(COMP_NAME + ".GetClsTipMicTipArea: ")
        let objCls = cssPracticeFluency.divHidden
        if (IsShowMicTipAgainFirst()) {
            objCls = cssPracticeFluency.divTipMicTipArea
        }
        return objCls
    }

    function GetClsTipUpDownTipArea() {
        console.log(COMP_NAME + ".GetClsTipUpDownTipArea: ")
        let objCls = cssPracticeFluency.divHidden
        if (IsShowNextTipFirst()) {
            objCls = cssPracticeFluency.divTipUpDownTipArea
        }
        return objCls
    }

    function GetClsScrollArea() {
        console.log(COMP_NAME + ".GetClsScrollArea")

        let objCls = null
        if (mobjTestSheet.Mode === TestSheetModeEnum.History) {
            objCls = cssPracticeFluency.divScrollAreaTestSheetModeHistory
        }
        else
        {
            objCls = cssPracticeFluency.divScrollAreaTestSheetModeNewAndTemp
        }
        return objCls
    }
    // #endregion Get ClassName and Style

    // #region Web Service After Process
    function GetPinyinFileContentAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetPinyinFileContentAfterProcess: ", ReturnData)

        window.gSession.App.PinyinFile = ReturnData

        InitSRPrerequisiteProcessEnd(true)
    }

    function UploadNewAssignmentTmpResultAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentTmpResultAfterProcess: ", ReturnData)

        UpdateCacheSinceSaveTemp(ReturnData)
        SetTestSheetObject(TestSheetModeEnum.Temp)
    }

    function GetNewAssignmentAssignTmpAnswerAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetNewAssignmentAssignTmpAnswerAfterProcess: ", ReturnData)
        mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext] = ReturnData
        console.log("mobjLUCacheContext: ", mobjLUCacheContext)

        GetPrerequisiteDataProcessEnd()
    }

    // #endregion Web Service After Process

    // #region Web Service
    function UploadNewAssignmentTmpResult()
    {
        console.log(COMP_NAME + ".UploadNewAssignmentTmpResult: ")
        let objRetryFuncRef = UploadNewAssignmentTmpResult
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_UploadAssignmentTmpResult_Title, window.gAppUI.ERR_UploadAssignmentTmpResult_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UploadNewAssignmentTmpResultCallback

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_UploadNewAssignmentTmpResult)

            let objCallData = {
                "Func": "UploadNewAssignmentTmpResult",
                "BookCategoryID": mstrBookCatID,
                "LessonID": props.LessonID,
                "ClassID": mintClassID,
                "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
                "Answer": JSON.stringify(marrAnswerList4Save),
                "Score": null,
                "ActionType": 1 // 給TmpResult使用； ActionType  1: 存（實際上會清除再存） 2: 清空    
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                }
                )
        }
    }

    function UploadNewAssignmentTmpResultCallback(Return)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentTmpResultCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()
        // setIsHistoryInited(true)

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UploadAssignmentTmpResult_No
        let strErrorTitle = window.gAppUI.ERR_UploadAssignmentTmpResult_Title
        let strErrMsg = window.gAppUI.ERR_UploadAssignmentTmpResult_Msg


        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UploadNewAssignmentTmpResultCallback: ErrNo: ", Return.ErrNo)
            console.log("UploadNewAssignmentTmpResultCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("UploadNewAssignmentTmpResultCallback Return.Data", Return.Data)

            UploadNewAssignmentTmpResultAfterProcess(Return.Data)
        }
    }

    function GetNewAssignmentAssignTmpAnswer()
    {
        console.log(COMP_NAME + ".GetNewAssignmentAssignTmpAnswer: ")
        let objRetryFuncRef = GetNewAssignmentAssignTmpAnswer
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Title, window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetNewAssignmentAssignTmpAnswerCallback

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetNewAssignmentAssignTmpAnswer)

            // Func: "GetNewAssignmentAssignAnswer"
            // AssignID: -1
            // Assignee: 459
            // BookCategoryID: "03"
            // LUCatSeqNo: 11
            // LessonID: "03001"

            let objCallData = {
                "Func": "GetNewAssignmentAssignTmpAnswer",
                "Assignee": window.gSession.Acc.ID,
                "BookCategoryID": mstrBookCatID,
                "LessonID": props.LessonID,
                "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
                "AssignID": -1
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                }
                )
        }
    }

    function GetNewAssignmentAssignTmpAnswerCallback(Return)
    {
        console.log(COMP_NAME + ".GetNewAssignmentAssignTmpAnswerCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()
        // setIsHistoryInited(true)


        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetNewAssignmentAssignAnswer_No
        let strErrorTitle = window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Title
        let strErrMsg = window.gAppUI.ERR_GetNewAssignmentAssignAnswer_Msg


        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetNewAssignmentAssignTmpAnswerCallback: ErrNo: ", Return.ErrNo)
            console.log("GetNewAssignmentAssignTmpAnswerCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetNewAssignmentAssignTmpAnswerCallback Return.Data", Return.Data)
            GetNewAssignmentAssignTmpAnswerAfterProcess(Return.Data)
        }
    }

    function GetAssignmentAssignAnswer()
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswer: ", props.LUInfo.LUCatSeqNo)

        let objRetryFuncRef = GetAssignmentAssignAnswer
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetAssignmentAssignAnswerCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAssignmentAssignAnswer)

            // Func: "GetNewAssignmentAssignAnswer"
            // AssignID: -1
            // Assignee: 459
            // BookCategoryID: "03"
            // LUCatSeqNo: 11
            // LessonID: "03001"

            let objCallData = {
                "Func": "GetNewAssignmentAssignAnswer",
                "Assignee": window.gSession.Acc.ID,
                "BookCategoryID": mstrBookCatID,
                "LessonID": props.LessonID,
                "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
                "AssignID": -1
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                }
                )

        }
    }

    function GetAssignmentAssignAnswerCallback(Return)
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswerCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetAssignmentAssignAnswer_No
        let strErrorTitle = window.gAppUI.ERR_GetAssignmentAssignAnswer_Title
        let strErrMsg = window.gAppUI.ERR_GetAssignmentAssignAnswer_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute)
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetAssignmentAssignAnswerCallback: ErrNo: ", Return.ErrNo)
            console.log("GetAssignmentAssignAnswerCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetAssignmentAssignAnswerCallback Return.Data", Return.Data)

            // 更新 Cache
            mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext] = Return.Data
        }

        console.log("完成 Step 1, 需進行 Step 2")
        // 取得 Temp Answer List
        GetNewAssignmentAssignTmpAnswer()
    }

    // 撈取歷史紀錄 歷史記錄 + 暫存的答案
    function GetPinyinFileContent()
    {
        console.log(COMP_NAME + ".GetPinyinFileContent")

        let objRetryFuncRef = GetPinyinFileContent

        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetPinyinFileContentCallback
            let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY_NODE_JS
            console.log("GetPinyinFileContent intWSServerType:", intWSServerType)
            
            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetPinyinFileContent)

            let objCallData = {
                "Func": "GetPinyinFileContent"
            }
            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef, intWSServerType)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    }

    function GetPinyinFileContentCallback(Return)
    {
        // Close Loading mask
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetPinyinFileContent_No
        let strErrorTitle = window.gAppUI.ERR_GetPinyinFileContent_Title
        let strErrMsg = window.gAppUI.ERR_GetPinyinFileContent_Msg


        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute)
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }
            console.log("GetPinyinFileContentCallback: ErrNo: ", Return.ErrNo)
            console.log("GetPinyinFileContentCallback: CalledErrNo: ", Return.CalledErrNo)

            InitSRPrerequisiteProcessEnd(false)
        }
        else
        {
            console.log("GetPinyinFileContentCallback Return.Data: ", Return.Data)

            GetPinyinFileContentAfterProcess(Return.Data)
        }
    }
    // #endregion Web Service

    // #region Speech Recognition and Audio Recorde
    
    function PlayUserRecordedVoiceOnTapHandler(AudioUrl, SentenceIndex) {
        console.log(COMP_NAME + ".PlayUserRecordedVoiceOnTapHandler: ", AudioUrl, SentenceIndex)

        SetPlayingAudioIndex(SentenceIndex, AudioType.StudentVoice)

        if (IsShowAudioTipFirst()) {
            // 如果目前有顯示 AudioTipFirst
            HideAudioTipFirst()
        }

        mintPlayAudioType = PlayAudioTypeEnum.UserRecordedAudio
        window.AudioLibs.PlayAudio(AudioUrl)

        setUpdateDataTime(new Date().getTime())
    }

    function PlaySentenceAudioOnTapHandler(AudioUrl, SentenceIndex) {
        console.log(COMP_NAME + ".PlaySentenceAudioOnTapHandler: ", AudioUrl, SentenceIndex)

        SetPlayingAudioIndex(SentenceIndex, AudioType.QuestionAudio)

        PlayImportAudio(PlayAudioTypeEnum.UserClickedAudio, AudioUrl)
        // window.AudioLibs.PlayAudio(mobjAnswer.UserAudio) // TEST

        setUpdateDataTime(new Date().getTime())
    }

    function PlaySentenceAudioAndStartSR() {
        console.log(COMP_NAME + ".PlaySentenceAudioAndStartSR")

        let strAudioFN = props.LUInfo.Sentence[mintCurrentSentenceIndex].AudioFN
        let strAudioUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Audio, strAudioFN)
        PlayImportAudio(PlayAudioTypeEnum.VocabularyAudio, strAudioUrl)
        setReadAloudState(ReadAloudStateEnum.QuestionAudioPlaying)
    }

    function PlayImportAudio(PlayAudioType, AudioUrl) {
        console.log(COMP_NAME + ".PlayImportAudio: ", PlayAudioType, AudioUrl)

        OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadAudioData)

        mintPlayAudioType = PlayAudioType
        window.AudioLibs.PlayAudio(AudioUrl)
    }

    function InitSREngineEnd(Successfully) {
        console.log(COMP_NAME + ".InitSREngineEnd: ", Successfully)

        if (Successfully) 
        {
            if (window.gSession.App.PinyinFile === null) 
            {
                GetPinyinFileContent()
            }
            else
            {
                InitSRPrerequisiteProcessEnd(true)
            }
        }
        else
        {
            InitSRPrerequisiteProcessEnd(false)
        }
    }

    function InitSREngineBegin() {
        console.log(COMP_NAME + ".InitSREngineBegin")
        
        OpenLoadingMask(window.gAppUI.MSG_LoadMask_InitSR)

        if (!window.gSession.App.InApp) {
            let blnIsAutoSR = true
            WebSpeech.Init(WebSpeechCallback, blnIsAutoSR)
        }
        else
        {
            console.log(COMP_NAME + ".InitSREngineBegin SRInApp")
            // SRInApp.Init(window.gSession.Acc.Credential, SRInAppCallback, SRInApp.RecModeEnum.Auto, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
            SRInApp.Init(window.gSession.Acc.Credential, SRInAppCallback, SRInApp.RecModeEnum.Auto)
        }
    }

    function SRInAppCallback(CallbackObj) {
        console.log(COMP_NAME + ".SRInAppCallback: ", CallbackObj);
        if (CallbackObj.Action === 'SREngineOpened') {
            console.log("SREngineOpened")

            CloseLoadingMask()
            InitSREngineEnd(true)
        }
        else if (CallbackObj.Action === 'SROnEnd') {
            // SRResults
            console.log("SRResults: ", CallbackObj.SRResults)
            setSrResult4Display(JSON.stringify(CallbackObj.SRResults))
            marrSRResults = CallbackObj.SRResults
            mobjAnswer.UserAudio = CallbackObj.AudioBase64

            ExecuteResultsProcess()
            UpdateTestSheetObject(mobjAnswer)
            if (mobjAnswer.IsPassed) {
                PlayImportAudio(PlayAudioTypeEnum.GameCorrectAnswer, mp3GameCorrectAnswer)
            }
            setReadAloudState(ReadAloudStateEnum.ResultProcessed)
            SRProcessEnd()
        }
        else if (CallbackObj.Action === 'SRNoResult') {
            console.log(COMP_NAME + ".SRNoResult")
            // richard: 20201117
            // 實驗結果，一直不講話，會 SRNoResult
            setReadAloudState(ReadAloudStateEnum.SRErrorProcessing)
            NoResultDetectedProcess()
        }
        else if (CallbackObj.Action === 'SROnInitError') {
            CloseLoadingMask()
            InitSREngineEnd(false)

            let strTitle = window.gAppUI.MSG_Alert_Title_SR_Err
            let strMessage = CallbackObj.ErrMessage
            let objAlertObject = {
                Header: strTitle,
                Body: strMessage,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [{
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }]
            }

            ShowAlert(objAlertObject)
        }
        else if (CallbackObj.Action === 'SROnError')  // SROnError
        {
            CloseLoadingMask()

            setReadAloudState(ReadAloudStateEnum.SRErrorProcessing)

            let strTitle = window.gAppUI.MSG_Alert_Title_SR_Err
            let strMessage = CallbackObj.ErrMessage
            let objAlertObject = {
                Header: strTitle,
                Body: strMessage,
                ShowCloseButton: false,
                CallbackRef: SRErrorAlertCallback,
                Buttons: [{
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }]
            }

            ShowAlert(objAlertObject)
        }
        else
        {
            console.log(COMP_NAME + ".SRInAppCallback Not Implemented Action: ", CallbackObj.Action)
        }
    }

    function SRErrorAlertCallback(CallbackObject) {
        console.log(COMP_NAME + ".SRErrorAlertCallback: ", CallbackObject)

        setReadAloudState(ReadAloudStateEnum.SRErrorProcessed)

        // NewSentenceInit()
        // let objCallbackData = {
        //     "Action": "ReadAloudErrorProcessed"
        // }
        // props.CallbackRef(objCallbackData)

        mintSRResultErrorCount = 0

        if (window.gSession.App.InApp) {
            // SetAnswerAfterAppEnterForeground()
            setReadAloudState(ReadAloudStateEnum.Inited)
            setIsSRPrerequisiteGotton(false)
            // InitSR()
        }
        else
        {
            setReadAloudState(ReadAloudStateEnum.Inited)
        }
    }

    function WebSpeechCallback(CallbackObj) {
        console.log(COMP_NAME + ".WebSpeechCallback: ", CallbackObj)

        // if (!mblnInitialized)
        // {
        //     // Richard： 避免 cleanup 之後還收到 speech callback
        //     // SR Start 之後，在還沒有結果之前，離開這個 LU, 就會收到
        //     return
        // }
        // 後來認為應該用 Remove Callback Ref 的方法
        // 所以在 cleanup 加： WebSpeech.RemoveEventHandlerRef()

        if (CallbackObj.Action === 'SREngineOpened') {
            CloseLoadingMask()
            // mobjInitResult.IsSRInited = true
            // mobjInitResult.IsSRInitedSuccessfully = true

            InitSREngineEnd(true)
            // InitSRPrerequisiteProcessEnd()
        }
        else if (CallbackObj.Action === 'SREngineInitFailed') {
            CloseLoadingMask()
            InitSREngineEnd(false)

            let objAlertObject = {
                Header: "",
                Body: window.gAppUI.ERR_SREngineInitFailed_Msg,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }

            ShowAlert(objAlertObject)
        }
        else if (CallbackObj.Action === 'SROnStart') {
            marrSRResults = []
            // console.log(COMP_NAME + ".SROnStart.mrefPropsArgs4UploadUserRecordedAudio.current: ", mrefPropsArgs4UploadUserRecordedAudio.current)

            mobjForceStopSRTimer = setTimeout(function () {
                console.log(COMP_NAME + " SROnStart SRStop Time: ", new Date().getTime())
                WebSpeech.SRStop()
            }, MAX_SILENCE_MS)

            // mobjArgs4UploadUserRecordedAudio
            mobjArgs4UploadUserRecordedAudio.TRSeqNo = props.LUInfo.Sentence[mintCurrentSentenceIndex].SeqNo
            mobjArgs4UploadUserRecordedAudio.TRPIndex = props.LUInfo.Sentence[mintCurrentSentenceIndex].ParagraphIdx

            mobjWebAudioRecorder.CallWebAudioRecorderToStart(mobjArgs4UploadUserRecordedAudio)
        }
        else if (CallbackObj.Action === 'SRNoResult') {
            console.log(COMP_NAME + ".SRNoResult")
            // richard: 20201117
            // 實驗結果，一直不講話，會 SRNoResult
            setReadAloudState(ReadAloudStateEnum.SRErrorProcessing)

            mobjWebAudioRecorder.CallWebAudioRecorderToStop()
            NoResultDetectedProcess()
        }
        else if (CallbackObj.Action === 'SROnError') {
            mobjWebAudioRecorder.CallWebAudioRecorderToStop()
        }
        else if (CallbackObj.Action === 'SROnResult') {
            setSrResult4Display(JSON.stringify(CallbackObj.SRResults))

            // mobjWebAudioRecorder.CallWebAudioRecorderToStop({ "QuestionIndex": props.SentenceID })
            // mobjWebAudioRecorder.CallWebAudioRecorderToStop({ "QuestionIndex": mintCurrentSentenceIndex })
            if (mobjForceStopSRTimer !== null) {
                clearTimeout(mobjForceStopSRTimer)
                mobjForceStopSRTimer = null
            }

            if (CallbackObj.IsFinalResult) {
                console.log("SR Is Final Result")

                // 收到 Final 了，就要求不再辨識
                WebSpeech.SRStop()
            }
            else
            {
                mobjForceStopSRTimer = setTimeout(function () {
                    console.log(COMP_NAME + ".SROnResult SRStop Time: ", new Date().getTime())
                    WebSpeech.SRStop()
                }, MAX_SILENCE_MS)
            }
        }
        else if (CallbackObj.Action === 'SROnEnd') {
            // SRResults
            console.log(COMP_NAME + ".SROnEnd SRResults: ", CallbackObj.SRResults)

            console.log("SROnEnd: props.SentenceID:", props.SentenceID)
            // console.log("SROnEnd: mrefPropsSentenceID.current:", mrefPropsSentenceID.current)
            // mobjWebAudioRecorder.CallWebAudioRecorderToStop({ "QuestionIndex": mrefPropsSentenceID.current })
            mobjWebAudioRecorder.CallWebAudioRecorderToStop({ "QuestionIndex": mintCurrentSentenceIndex })

            // debugging message
            setSrResult4Display(JSON.stringify(CallbackObj.SRResults))
            // richard 20210808 本來應該在這裡開始評分，但擔心沒有 EndStream
            // 所以延後到 EndStreaming
            marrSRResults = CallbackObj.SRResults
        }
        else
        {
            console.log("Cannot process Action: ", CallbackObj.Action)
        }
    }

    function NoResultDetectedProcess() {
        console.log(COMP_NAME + ".NoResultDetectedProcess: ")

        mintSRResultErrorCount++
        console.log("mintSRResultErrorCount: ", mintSRResultErrorCount)
        if (mintSRResultErrorCount < 3) {
            console.log("No Result <3")

            PlayImportAudio(PlayAudioTypeEnum.VoiceNotDetected, mp3VoiceNotDetected)
        }
        else
        {
            mintSRResultErrorCount = 0

            let strTitle = ""
            let strMessage = window.gAppUI.MSG_Alert_Google_SR_Err_NoSpeechAndNoResultMeetUpperBound
            let objAlertObject = {
                Header: strTitle,
                Body: strMessage,
                ShowCloseButton: false,
                CallbackRef: NotDetectedAlertCallback,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: false
                    }
                ]
            }

            ShowAlert(objAlertObject)
        }
    }

    function NotDetectedAlertCallback(CallbackObject) {
        console.log(COMP_NAME + ".NotDetectedAlertCallback: ", CallbackObject)

        setReadAloudState(ReadAloudStateEnum.SRErrorProcessed)
        SRProcessEnd()
        CloseLoadingMask()
    }

    function InitSRPrerequisiteProcessEnd(Successfully) {
        console.log(COMP_NAME + ".InitSRPrerequisiteProcessEnd: ", Successfully)

        if (Successfully) {
            setReadAloudState(ReadAloudStateEnum.Inited)
            setIsSRPrerequisiteGotton(true)

            SRProcessBegin()
        }
        else
        {
            setReadAloudState(ReadAloudStateEnum.InitedSRFailed)

            SRProcessEnd()
        }
    }

    function GenerateRecorderCore() {
        console.log(COMP_NAME + ".GenerateRecorderCore: ", mblnSRSupport)

        let objWebAudioReorder = null
        if (!window.gSession.App.InApp && mblnSRSupport) {
            objWebAudioReorder = <WebAudioRecorderLibs.WebAudioRecorderCore ref={mrefWebAudioRecorderCore}
                NeedUploadUserRecordedAudio={true} Credential={window.gSession.Acc.Credential} Env={window.gSession.App.Env}
                CallbackRef={WebAudioRecorderCoreCallback} />
        }

        return objWebAudioReorder
    }

    function InitWebAudioRecorderBegin() {
        console.log(COMP_NAME + ".InitWebAudioRecorderBegin: ")

        OpenLoadingMask(window.gAppUI.MSG_LoadMask_InitWebAudioRecording)

        setIsWebAudioRecorderOn(true)
    }

    function InitWebAudioRecorderEnd(Successfully) {
        console.log(COMP_NAME + ".InitWebAudioRecorderEnd: ", Successfully)

        if (Successfully) {
            // Init SR Process 的下一步
            InitSREngineBegin()
        }
        else
        {
            setIsWebAudioRecorderOn(false)

            InitSRPrerequisiteProcessEnd(false)
        }
    }

    function WebAudioRecorderCoreCallback(CallbackObj) {
        console.log(COMP_NAME + ".WebAudioRecorderCoreCallback: ", CallbackObj)

        if (CallbackObj.Action === 'WebAudioRecorderReportReady') {
            console.log("Web Audio Recorder Inited")
            // 這時候才可以拿掉 Loading Mask

            mobjWebAudioRecorder = mrefWebAudioRecorderCore.current
            CloseLoadingMask()

            InitWebAudioRecorderEnd(true)
        }
        else if (CallbackObj.Action === 'WebAudioRecorderReportInitErr') {
            console.log("Web Audio Recorder Init Err")

            CloseLoadingMask()
            // mobjInitResult.isWebAudioRecorderInited = true

            setReadAloudState(ReadAloudStateEnum.InitedWebAudioRecorderFailed)
            InitWebAudioRecorderEnd(false)

            if (mobjWebAudioRecorder !== null) {
                mobjWebAudioRecorder.UnregisterCallbackRef()
                mobjWebAudioRecorder = null
            }

            // 增加 桌上型電腦 偵測不到麥克風裝置 錯誤訊息判斷      Tim21.10.26
            let strBody = ""
            // if (CallbackObj.ErrorCode === window.gConst.WAR_ERROR_INIT_SETTING_ALLOW_MICROPHONE_ACCESS) {
            if (CallbackObj.ErrorCode === WebAudioRecorderLibs.WARErrorEnum.WAR_ERROR_INIT_SETTING_ALLOW_MICROPHONE_ACCESS) {
                    strBody = window.gAppUI.MSG_Alert_Msg_WebAudioRecorderInitErr
            }
            // else if (CallbackObj.ErrorCode === window.gConst.WAR_ERROR_INIT_DETECT_MICROPHONE) {
            else if (CallbackObj.ErrorCode === WebAudioRecorderLibs.WARErrorEnum.WAR_ERROR_INIT_DETECT_MICROPHONE) {
                    // -1 // 桌上型電腦 偵測不到麥克風裝置
                strBody = window.gAppUI.MSG_Alert_Msg_WebAudioRecorderDetectMicrophone
            }
            else
            {
                strBody = CallbackObj.ErrorCode.toString() + ": " + CallbackObj.ErrorMsg
            }

            let objAlertObject = {
                Header: window.gAppUI.MSG_Alert_Title_WebAudioRecorderInitErr,
                Body: strBody,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }

            ShowAlert(objAlertObject)
        }
        else if (CallbackObj.Action === 'WebAudioRecorderClosed') {
            console.log(COMP_NAME + ".WebAudioRecorderCoreCallback WebAudioRecorderClosed")
            console.log(COMP_NAME + ".WebAudioRecorderCoreCallback CallbackObj: ", CallbackObj)
            // window.AudioLibs.PlayAudio(mobjAnswer.UserAudio) // TEST
            // 這時候會拿到 base64 的 User mp3 錄音
            // 但 要等 後端錄音程式 檔案存好後 再繼續下面的流程
            // 所以 改 WebAudioRecorderEndStreaming 再處理
        }
        else if (CallbackObj.Action === 'WebAudioRecorderEndStreaming') {
            console.log(COMP_NAME + ".WebAudioRecorderCoreCallback WebAudioRecorderEndStreaming CallbackObj: ", CallbackObj)
            console.log(COMP_NAME + ".WebAudioRecorderCoreCallback WebAudioRecorderEndStreaming AudioBase64: ", CallbackObj.AudioBase64.length)

            if (CallbackObj.CallbackObject !== null) {
                console.log("這個回傳是正常 SR 結果! 例如: SROnEnd!")
                mobjAnswer.UserAudio = CallbackObj.AudioBase64

                ExecuteResultsProcess()
                // marrAnswerList[mintCurrentSentenceIndex] = JSON.parse(JSON.stringify(mobjAnswer))
                UpdateTestSheetObject(mobjAnswer)
                if (mobjAnswer.IsPassed) {
                    PlayImportAudio(PlayAudioTypeEnum.GameCorrectAnswer, mp3GameCorrectAnswer)
                }
                setReadAloudState(ReadAloudStateEnum.ResultProcessed)

                SRProcessEnd()
            }
            else
            {
                console.log("這個回傳不是正常 SR 結果的結束! 例如: RNoResult!")
            }
        }
        else if (CallbackObj.Action === 'WebAudioRecorderError') {
            console.log(COMP_NAME + ".WebAudioRecorderCoreCallback WebAudioRecorderError")
        }
    }

    function UpdateTestSheetObject(UserAnswer) {
        console.log(COMP_NAME + ".UpdateTestSheetObject: ", UserAnswer)

        console.log("mobjTestSheet: ", mobjTestSheet)
        console.log("mintCurrentSentenceIndex: ", mintCurrentSentenceIndex)

        mobjTestSheet.Dirty = true
        let objTestSheetCurrentItem = mobjTestSheet.Sentence[mintCurrentSentenceIndex].Answer
        console.log("objTestSheetCurrentItem: ", objTestSheetCurrentItem)

        objTestSheetCurrentItem.Score = UserAnswer.Score
        objTestSheetCurrentItem.AudioUrl = UserAnswer.UserAudio
        objTestSheetCurrentItem.UserAnswer.CharScore = UserAnswer.CharScore
        objTestSheetCurrentItem.UserAnswer.IsPassed = UserAnswer.IsPassed

        console.log("mobjTestSheet: ", mobjTestSheet)
    }

    function ExecuteResultsProcess() {
        console.log(COMP_NAME + ".ExecuteResultsProcess: ", marrSRResults)

        let arrSRResultSentence = marrSRResults
        console.log("arrSRResultSentence: ", arrSRResultSentence)
        let objSentence = props.LUInfo.Sentence[mintCurrentSentenceIndex]
        console.log("Sentence Obj: ", props.LUInfo.Sentence[mintCurrentSentenceIndex])
        let objResultOfSentence = {}
        let strCorrectAnswerWithoutSymbol = objSentence.TextWithoutSymbol
        let strCorrectAnswerWithSymbol = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? objSentence.Major : objSentence.Minor
        console.log("ExecuteResultsProcess.strCorrectAnswerWithoutSymbol: ", strCorrectAnswerWithoutSymbol)
        console.log("ExecuteResultsProcess.strCorrectAnswerWithSymbol: ", strCorrectAnswerWithSymbol)

        // let arrResultSentenceWithoutSymbol = GetSymbolProcessed(arrSRResultSentence)
        // let arrResultSentence = GetResultNumberProcessed(arrResultSentenceWithoutSymbol)

        // // richard 20211005 手動測試資料
        // // arrResultSentence = ['莱特兄弟一二了人类历史上哇哇的一架飞机飞机飞机', '莱特兄弟十二了人类历史上哇哇的一架飞机飞机飞机','莱特兄弟12了人类历史上哇哇的一架飞机飞机飞机']
        // // arrResultSentence = ['莱特兄弟一二了人类历史上哇哇的一架飞机飞机飞机', '莱特兄弟发明了人类历史上第一架飞机','莱特兄弟12了人类历史上哇哇的一架飞机飞机飞机']
        // // arrResultSentence = ['莱特兄弟一二了人类历史上哇哇的一架飞机飞机飞机']
        // // arrResultSentence = ['嗨嗨你好吗']
        // // arrResultSentence = ['老學好']
        // // arrResultSentence = ['莱特兄弟人类历史一架飞机']
        // // arrResultSentence = ['莱特兄弟任类历史飞句']
        // // arrResultSentence = ['莱特兄弟发明了人类历史上第一架飞机']
        // // strCorrectAnswerWithoutSymbol = '莱特兄弟发明了人类历史上第一架飞机'
        // // strCorrectAnswerWithoutSymbol = '莱特兄弟发明了人类历史上第一架飞机'
        // // strCorrectAnswerWithoutSymbol = '老師好同學們好'
        // // strCorrectAnswerWithoutSymbol = '你好吗'
        // // console.log("語音：", arrResultSentence)
        // // console.log("答案：", strCorrectAnswerWithoutSymbol)
        //

        
        // objResultOfSentence = GetProcessedResult(arrResultSentence, strCorrectAnswerWithoutSymbol)
        objResultOfSentence = SRFunctions.GetProcessedResult(window.gSession.App.PinyinFile, arrSRResultSentence, strCorrectAnswerWithoutSymbol)
        console.log("objResultOfSentence: ", objResultOfSentence)

        let arrCharScore = FormatResultCharScore(objResultOfSentence, strCorrectAnswerWithSymbol, strCorrectAnswerWithoutSymbol)
        console.log("arrCharScore: ", arrCharScore)

        mobjAnswer.IsPassed = objResultOfSentence.IsPassed
        mobjAnswer.Score = objResultOfSentence.AvgScore // 單題的辨識結果分數是小數點 e.g. 0.53125
        mobjAnswer.CharScore = [].concat(arrCharScore)
        console.log("ExecuteResultsProcess: mobjAnswer:", mobjAnswer)
    }

    function FormatResultCharScore(UserPronounceResultOfSentence, CorrectAnswerWithSymbol, CorrectAnswerWithoutSymbol) {
        console.log(COMP_NAME + ".FormatResultCharScore")
        console.log("FormatResultCharScore: UserPronounceResultOfSentence:", UserPronounceResultOfSentence) // 使用者回答的物件資訊
        console.log("FormatResultCharScore: CorrectAnswerWithSymbol:", CorrectAnswerWithSymbol) // e.g. 你好！ // 正確答案 包含符號
        console.log("FormatResultCharScore: CorrectAnswerWithoutSymbol:", CorrectAnswerWithoutSymbol) // 你好 // 正確答案 不含符號

        let arrCharScore = []

        // CorrectAnswerWithoutSymbol = "我上他也上" // TEST // 使用者唸出的字串
        // CorrectAnswerWithSymbol = "我上，他也上。"
        let strCorrectAnswerWithoutSymbol = CorrectAnswerWithoutSymbol
        let arrCorrectAnswerWithoutSymbol = strCorrectAnswerWithoutSymbol.split("")

        let strCorrectAnswerWithSymbol = CorrectAnswerWithSymbol
        let arrCorrectAnswerWithSymbol = strCorrectAnswerWithSymbol.split("")

        // console.log("FormatResultCharScore: strCorrectAnswerWithoutSymbol.length:", strCorrectAnswerWithoutSymbol.length)
        // console.log("FormatResultCharScore: arrCorrectAnswerWithoutSymbol:", arrCorrectAnswerWithoutSymbol)
        // console.log("FormatResultCharScore: arrCorrectAnswerWithSymbol:", arrCorrectAnswerWithSymbol)
        // console.log("FormatResultCharScore: UserPronounceResultOfSentence:", UserPronounceResultOfSentence)
        // console.log("FormatResultCharScore: UserPronounceResultOfSentence.CharTopScore.length:", UserPronounceResultOfSentence.CharTopScore.length)

        if (UserPronounceResultOfSentence.AvgScore < 1) // UserPronounceResultOfSentence.AvgScore < 1 表示存在唸不標準的字, UserPronounceResultOfSentence.AvgScore === 1 表示全對
        {
            console.log("arrCorrectAnswerWithSymbol: ", arrCorrectAnswerWithSymbol)
            let indexCorrectAnswerWithSymbol = 0
            let indexCorrectAnswerWithoutSymbol = 0
            let intIndexCharScore = 0

            let arrSymbol = ["，", ",", "。", ".", "？", "#", "／", "/", "；", ";"
                , "“", "”", "❞", "❝", "「", "」", "『", "』", "：", ":"
                , "、", "⋯⋯", "……", "…", "﹁", "﹂", "！", "!", "《》"
                , "_", "＿", "‘", "’", "～", "~", "·", "（", "）"
                , "-", "⋯", "《", "》", "－", "•", "・", "——", "﹐", "—"
                , "?", "(", ")", "*"]

            while (indexCorrectAnswerWithSymbol < arrCorrectAnswerWithSymbol.length) {
                // console.log("indexCorrectAnswerWithSymbol: arrCorrectAnswerWithSymbol[indexCorrectAnswerWithSymbol]", indexCorrectAnswerWithSymbol, arrCorrectAnswerWithSymbol[indexCorrectAnswerWithSymbol])
                if (UserPronounceResultOfSentence.AvgScore === 0) {
                    arrCharScore[intIndexCharScore] = 0; // 平均是0分 表示所有都是0分
                    console.log("FormatResultCharScore:0 arrCharScore:", arrCharScore.join())
                    console.log("arrCharScore.length:", arrCharScore.length)
                    indexCorrectAnswerWithSymbol++
                    intIndexCharScore++
                }
                else if (arrSymbol.includes(arrCorrectAnswerWithSymbol[indexCorrectAnswerWithSymbol])) {
                    arrCharScore[intIndexCharScore] = -1 // -1
                    console.log("FormatResultCharScore:1 arrCharScore:", arrCharScore.join())
                    console.log("arrCharScore.length:", arrCharScore.length)
                    indexCorrectAnswerWithSymbol++
                    intIndexCharScore++
                }
                else if (
                    (UserPronounceResultOfSentence.CharTopScore.length < arrCorrectAnswerWithoutSymbol.length) && // 唸的字少於答案的字 e.g. UserPronounceResultOfSentence.CharTopScore.length < arrCorrectAnswerWithoutSymbol.length
                    (typeof (UserPronounceResultOfSentence.CharTopScore[indexCorrectAnswerWithoutSymbol]) === "undefined") // 目前的字元 已經超過使用者唸的字數
                ) {
                    arrCharScore[intIndexCharScore] = 0 // 使用者唸不夠的字數不夠時 都給0分
                    console.log("FormatResultCharScore:4 arrCharScore:", arrCharScore.join())
                    console.log("arrCharScore.length:", arrCharScore.length)
                    indexCorrectAnswerWithoutSymbol++
                    indexCorrectAnswerWithSymbol++
                    intIndexCharScore++
                }
                else
                {
                    arrCharScore[intIndexCharScore] = UserPronounceResultOfSentence.CharTopScore[indexCorrectAnswerWithoutSymbol]
                    // console.log("indexCorrectAnswerWithoutSymbol:", indexCorrectAnswerWithoutSymbol)
                    // console.log("UserPronounceResultOfSentence.CharTopScore[indexCorrectAnswerWithoutSymbol]:", UserPronounceResultOfSentence.CharTopScore[indexCorrectAnswerWithoutSymbol])
                    // console.log("FormatResultCharScore:2 arrCharScore:", arrCharScore.join())
                    // console.log("arrCharScore.length:", arrCharScore.length)
                    indexCorrectAnswerWithoutSymbol++
                    indexCorrectAnswerWithSymbol++
                    intIndexCharScore++
                }
            }
        }
        console.log("FormatResultCharScore: arrCharScore:", arrCharScore.join())
        console.log("FormatResultCharScore: arrCharScore:", arrCharScore)

        return arrCharScore
    }

    function StartSRProcess() {
        console.log(COMP_NAME + ".StartSRProcess: ")

        setSrResult4Display("")
        mobjAnswer = {
            IsPassed: false,
            UserAudio: "",
            Score: SCROE_DEFAULT,
            ScoreExtInfo: {
                "CharScore": []
            }
        }
        setReadAloudState(ReadAloudStateEnum.UserRecording)

        if (mobjForceStopSRTimer !== null) {
            clearTimeout(mobjForceStopSRTimer)
            mobjForceStopSRTimer = null
        }

        let objCallbackData = {
            "Action": "SRStarted"
        }
        props.CallbackRef(objCallbackData)

        // mdatSpentTimeStartTime = new Date()

        if (window.gSession.App.InApp) {
            mobjArgs4UploadUserRecordedAudio.TRSeqNo = props.LUInfo.Sentence[mintCurrentSentenceIndex].SeqNo
            mobjArgs4UploadUserRecordedAudio.TRPIndex = props.LUInfo.Sentence[mintCurrentSentenceIndex].ParagraphIdx
            SRInApp.SRStart(mobjArgs4UploadUserRecordedAudio)
        }
        else
        {
            WebSpeech.SRStart()
        }
    }
    // #endregion Speech Recognition and Audio Recorder

    // #region Component
    // #endregion Component

    // #region Rende
    

    function RenderGoogleClassrommButton() {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina) {
            // 非China
            if (!window.gSession.App.InApp) {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if (intCheckResult === -1) {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssPracticeFluency.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }

        return objBlockGoogleClassroomButton
    }

    function RenderHeaderLeftArea() {
        let strTitleEN = props.SubSectionDef.Name
        let strTitleCN = ""
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) {
            strTitleCN = props.SubSectionDef.MajorName
        }
        else
        {
            strTitleCN = props.SubSectionDef.MinorName
        }

        return (
            <div className={cssPracticeFluency.divTitleLeftArea}>
                {RenderGoogleClassrommButton()}
                <div className={cssPracticeFluency.divTitleSubArea}>
                    <div className={cssPracticeFluency.divLessonIcon}></div>
                    <div className={cssPracticeFluency.divLUTitleTextEN}>
                        {strTitleEN}
                    </div>
                    <div className={cssPracticeFluency.divDividerBar}></div>
                    <div className={cssPracticeFluency.divLUTitleTextCN}>
                        {strTitleCN}
                    </div>
                </div>
            </div>
        )
    }

    function RenderHeaderRightArea() {
        console.log(COMP_NAME + ".RenderHeaderRightArea: ")

        return (
            <>
                <div className={cssPracticeFluency.divTitleRightArea}>
                    <div className={cssPracticeFluency.divScoreTitle}>
                        {window.gAppUI.LBL_YourScore}:
                    </div>
                    <div className={cssPracticeFluency.divTitleRightScore}>
                        {GetTextYourScore()}
                    </div>

                    <div className={cssPracticeFluency.divTitleRightBar}></div>

                    <div className={GetClsButtonHistory(mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext], mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]
                    )} onClick={() => HistoryOnTapHandler()}>
                        <div className={cssPracticeFluency.divIconHistory}>
                        </div>
                        <div className={cssPracticeFluency.divTitleButtonText}>
                            {window.gAppUI.BTN_History}
                        </div>
                    </div>

                    <div className={GetClsBarOnTheLeftOfSave(mobjTestSheet.Mode)}></div>

                    <div className={GetClsButtonSave()} onClick={() => SaveOnTapHandler()}>
                        <div className={cssPracticeFluency.divIconSave}></div>
                        <div className={cssPracticeFluency.divTitleButtonText}>
                            {window.gAppUI.BTN_Save}
                        </div>
                    </div>
                    <div className={cssPracticeFluency.divTitleRightBar}></div>
                    <div className={GetClsButtonRetry(mblnPracticeEnable)} onClick={() => RetryOnTapHandler()}>
                        <div className={cssPracticeFluency.divIconRetry}></div>
                        <div className={cssPracticeFluency.divTitleButtonText}>
                            {PackageVariablesLibs.UISettings.BTN_Retry}
                        </div>
                    </div>
                    <div className={GetClsButtonSubmit(mblnPracticeEnable)} onClick={() => SubmitOnTapHandler()}>
                        <div className={cssPracticeFluency.divIconSubmit}></div>
                        <div className={cssPracticeFluency.divTitleButtonText}>
                            {window.gAppUI.BTN_Submit}
                        </div>
                    </div>
                </div>
            </>
        )
    }

    function RenderHeader() {
        // console.log(COMP_NAME + ".RenderHeader")

        let objRenderHeaderLeft = null
        let objRenderHeaderRight = null

        if (isDataPrerequisiteGotton) {
            objRenderHeaderRight = RenderHeaderRightArea()
        }
        objRenderHeaderLeft = RenderHeaderLeftArea()


        return (
            <>
                {objRenderHeaderLeft}
                {objRenderHeaderRight}
            </>
        )
    }

    function RenderSentenceRowBottomCell(Answer, QuestionText, SentenceIndex) {
        // console.log(COMP_NAME + ".RenderSentenceRowBottomCell.Answer:", Answer, SentenceIndex)
        let objBlock = null
        if (
            (Answer !== null) &&
            (parseFloat(Answer.Score) >= 0)
        ) {
            objBlock = (
                <>
                    <div className={GetClsUserVoiceButton(Answer.AudioUrl, SentenceIndex)} onClick={() => PlayUserRecordedVoiceOnTapHandler(Answer.AudioUrl, SentenceIndex)}></div>
                    <div className={GetClsSentenceScore(Answer.Score)}>{GetSentenceScore(Answer.Score)}</div>
                    <ReadAloudAns ReadAloudAnswer={Answer} QuestionText={QuestionText} />
                </>
            )
        }

        return objBlock
    }

    function RenderSentenceList() {
        // console.log(COMP_NAME + ".RenderSentenceList")

        let strMainCharacterID = "" // 排版用 第一個出現的是主角 主角的圖示 放在左邊 其他角色都放在右側

        if (mobjTestSheet.Sentence.length > 0) {
            strMainCharacterID = mobjTestSheet.Sentence[0].Question.Character.ID
            console.log("strMainCharacterID:", strMainCharacterID)
        }

        return (
            <div ref={mrefScrollArea} className={GetClsScrollArea()}>
                {mobjTestSheet.Sentence.map((Item, SentenceIndex) =>
                    <div key={SentenceIndex} className={cssPracticeFluency.divSentenceListRowAreaOuter} name={"nameScrollSentence"}>
                        <div className={cssPracticeFluency.divSentenceListRowAreaLeft}>
                            <div className={cssPracticeFluency.divLeftCharacterName}>{GetLeftCharacterName(strMainCharacterID, Item.Question.Character.ID, Item.Question.Character.Name)}</div>
                            <div className={GetClsLeftAvator(strMainCharacterID, Item.Question.Character.ID)}></div>
                        </div>
                        <div className={cssPracticeFluency.divSentenceListRowArea}>
                            <div className={GetClsCellTop(SentenceIndex, mblnPracticeEnable)}>
                                <div className={GetClsSentenceAudioButton(Item.Question.AudioUrl, SentenceIndex)} onClick={() => PlaySentenceAudioOnTapHandler(Item.Question.AudioUrl, SentenceIndex)}></div>
                                <div className={cssPracticeFluency.divSentenceQuestionText}>{Item.Question.Text}</div>
                            </div>
                            <div className={GetClsCellBottom(Item.Answer)}>
                                {RenderSentenceRowBottomCell(Item.Answer, Item.Question.Text, SentenceIndex)}
                            </div>
                        </div>
                        <div className={cssPracticeFluency.divSentenceListRowAreaRight}>
                            <div className={cssPracticeFluency.divRightCharacterName}>{GetRightCharacterName(strMainCharacterID, Item.Question.Character.ID, Item.Question.Character.Name)}</div>
                            <div className={GetClsRightAvator(strMainCharacterID, Item.Question.Character.ID)}></div>
                        </div>
                        {RenderAudioTip(Item.Question.AudioUrl, SentenceIndex)}
                    </div>
                )}
            </div>
        )
    }

    function RenderAudioTip(AudioUrl, SentenceIndex) {
        console.log(COMP_NAME + ".RenderAudioTip: ")

        let objBlock = null
        if (
            (AudioUrl !== null) &&
            (AudioUrl !== "")
        ) {
            if (
                (SentenceIndex === mintCurrentSentenceIndex) &&
                (IsShowAudioTipFirst())
            ) {
                // 目前是指到這一個Sentence
                objBlock = (
                    <div className={cssPracticeFluency.divTipAudioTipArea}>
                        <div className={cssPracticeFluency.divTipAudioTipText}>
                            {window.gAppUI.LBL_AudioTip}
                        </div>
                    </div>
                )
            }
        }

        return objBlock
    }

    function RenderContent() {
        // console.log(COMP_NAME + ".RenderContent: ")
        console.log("mobjTestSheet: ", mobjTestSheet)

        return (
            <>
                {RenderSentenceList()}
            </>
        )
    }

    function RenderHistoryContent() {
        // console.log(COMP_NAME + ".RenderHistoryContent: ")
        console.log("mobjTestSheet: ", mobjTestSheet)

        let objSentenceList = RenderSentenceList()

        return (
            <div ref={mrefScrollArea} className={cssPracticeFluency.divScrollAreaHistory}>
                {objSentenceList}
            </div>
        )
    }

    function RenderMain(PrerequisiteGotton) {
        // console.log(COMP_NAME + ".RenderMain: ", PrerequisiteGotton)

        let objContent = null
        let objWebAudioReorder = null
        let objSRArea = null

        if (PrerequisiteGotton) {
            if (isWebAudioRecorderOn) {
                objWebAudioReorder = GenerateRecorderCore()
            }

            if (mobjTestSheet.Mode !== TestSheetModeEnum.History) {
                objContent = RenderContent()
                objSRArea = RenderSpeedRecognitionArea()
            }
            else
            {
                objContent = RenderHistoryContent()
            }
        }
        return (
            <div className={cssPracticeFluency.divContentArea} >
                {objWebAudioReorder}
                {objContent}
                {objSRArea}
            </div>
        )
    }

    function RenderDebugArea() {
        // console.log(COMP_NAME + ".RenderDebugArea: ")
        console.log("mintCurrentSentenceIndex: ", mintCurrentSentenceIndex)

        let objSentence = props.LUInfo.Sentence[mintCurrentSentenceIndex]
        let strCorrectAnswerWithSymbol = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? objSentence.Major : objSentence.Minor

        return (
            <div className={cssPracticeFluency.divDebugArea}>
                <div>Question {mintCurrentSentenceIndex + 1} of {mintTotalSentence}: {strCorrectAnswerWithSymbol}</div>
                <div>SR Result: {srResult4Display}</div>
                <div>Score: {mobjAnswer.Score}</div>
                {/* <div onClick={() => Debug4UserAudioPlay()}>Play User Recorded Audio</div> */}
            </div>
        )
    }

    // 不允許編輯的動畫文字
    function RenderAnimationMessageAreaForPracticeDisable(StatePracticeEnable) {
        console.log(COMP_NAME + ".RenderAnimationMessageAreaForPracticeDisable: ")
        let objBlock = null
        if (!StatePracticeEnable) {
            objBlock = (
                <div className={cssPracticeFluency.divAnimationMessageAreaForPracticeDisable}>
                    {mstrPracticeDisableMessage}
                </div>
            )
        }
        return objBlock
    }

    function RenderSpeedRecognitionArea() {
        // console.log(COMP_NAME + ".RenderSpeedRecognitionArea: ")
        console.log("mintCurrentSentenceIndex: ", mintCurrentSentenceIndex)

        let objDebugArea = null
        // if (
        //     (SHOW_SR_RESULT_DEBUG) &&
        //     (window.Globals.IsApplicationLogDump())
        // )        
        // // if (SHOW_SR_RESULT_DEBUG && process.env.REACT_APP_LOG_DUMP)      // 不確定 是否Richard想錯 改錯，先恢復之前的IsApplicationLogDump判斷    Tim23.09.11
        // { 
        //     objDebugArea = RenderDebugArea()
        // }

        // 建議 用Env環境參數 去判斷，以防 測試 一定要 跑到 Release 才會有辦法驗證      Tim23.09.11
        if (
            (SHOW_SR_RESULT_DEBUG) &&
            (window.gSession.App.Env !== "Production")
            )
        { 
            // 判斷 環境變數 非Production，才顯示       Tim23.09.11
            objDebugArea = RenderDebugArea()
        } // end of if (window.gSession.App.Env !== "Production")

        return (
            <div className={cssPracticeFluency.divSRAndUpDownSentenceButtonArea}>
                {/* <div className={cssPracticeFluency.divSRAndUpDownSentenceLeft}></div> */}
                <div className={cssPracticeFluency.divSpeechRecognitionArea}>
                    <div className={cssPracticeFluency.divTapToStartRecording}>{GetTextTapToStartRecording()}</div>
                    <div className={GetClsSpeechRecognitionButtonArea(mblnPracticeEnable)} onClick={() => SpeechRecognitionOnTapHandler()}></div>
                    <div className={cssPracticeFluency.divQuestionNumberText}>
                        {(mintCurrentSentenceIndex + 1).toString().PadLeft(2)}
                        {" " + window.gAppUI.LBL_PageOf + " "}
                        {mintTotalSentence.toString().PadLeft(2)}
                    </div>
                    <div className={cssPracticeFluency.divQuestionNumberSentenceText}>{window.gAppUI.LBL_Sentences}</div>

                    <div className={cssPracticeFluency.divUpDownArea}>
                        <div className={GetClsUpBottom(mblnPracticeEnable)} onClick={() => PreviousSentenceOnTapHandler()}></div>
                        <div className={GetClsDownBottom(mblnPracticeEnable)} onClick={() => NextSentenceOnTapHandler()}></div>
                        <div className={GetClsTipUpDownTipArea()}>
                            <div className={cssPracticeFluency.divTipUpDownTipText}>
                                {window.gAppUI.LBL_NextTip}
                            </div>
                        </div>
                    </div>
                    <div className={GetClsTipMicTipArea()}>
                        <div className={cssPracticeFluency.divTipMicTipText}>
                            {window.gAppUI.LBL_MicTipAgain}
                        </div>
                    </div>
                    {objDebugArea}
                </div>
            </div>
        )
    }

    return (
        <>
            {RenderHeader()}
            {RenderMain(isDataPrerequisiteGotton)}
            {RenderAnimationMessageAreaForPracticeDisable(practiceEnable)}
        </>
    )
    // #endregion Render
}
export default PracticeFluency